import React, { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  Grid2,
  Container,
  useTheme,
  Divider,
  LinearProgress,
  Chip,
  Backdrop,
  CircularProgress,
  Theme,
  alpha,
} from "@mui/material";
import CustomTypography from "../../../../../../views/components/common/form/CustomTypography";
import AppButton from "../../../../../../views/components/common/buttons/AppButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RefreshIcon from "@mui/icons-material/Refresh";
import HistoryIcon from "@mui/icons-material/History";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import SummaryIcon from "../../../../../../assets/reloadicon.png";
import PrintInwardicon from "../../../../../../assets/printinward.png";
import QCrejectionIcon from "../../../../../../assets/rawqc.png";
import RawInwardIcon from "../../../../../../assets/rawinward.png";
import QCrejectionIcon2 from "../../../../../../assets/setting.png";
import PrintOutwardicon from "../../../../../../assets/outward.png";
import vendorIcon from "../../../../../../assets/vendoricon.png";
import FormTextField from "../../../../../../views/components/common/form/FormTextField";
import CustomTextField from "../../../../../../views/components/common/textFields/TextField";
import { useStores } from "../../../../use-stores";
import { isPodOrderType } from "../../../../../../models/Project/OrderType";
import PodProjectOpsDisabledBanner from "../../../components/projects/PodProjectOpsDisabledBanner";
import DatePicker2 from "../../../../../../views/components/common/textFields/DatePicker2";
import dayjs from "dayjs";
import AppSearchDropDown2 from "../../../../../../views/components/common/filter/AppSearchDropdown2";
import { useNotification } from "../../../../../../utils/NotificationsContext";
import SummaryDrawer from "../../../../views/components/summary/AppSummary";
import UploadIcon from "../../../../../../assets/uploadimg.png";
import ImageUploadDialog from "../../../../../../views/components/common/upload/ImageUploadDialog";
import { observer } from "mobx-react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  InventoryOpsQtyFields,
  InventoryOpsSkuVariantLine,
  PrintInwardCancelReq,
  PrintInwardQcReq,
  PrintInwardQtyReq,
  PrintOutwardCancelReq,
  PrintOutwardReq,
  InventoryOpsReversalAction,
  InventoryOpsReversalReq,
  InventoryOpsReversalStage,
  RawInwardCancelReq,
  RawInwardQcReq,
  RawInwardQtyReq,
  RawInwardReceivedReq,
  PrintInwardReceivedReq,
  VendorInvoice,
  VendorInvoiceType,
} from "../../../../../../models/ProjectManagement/InventoryOpsRequests";
import ImageAPI from "../../../../api/ImageAPI";
import ImageCarousel from "../../../../../../views/components/common/carousel/ImageCarousel";
import ImageGalleryWithDialog from "../../../../../../views/components/common/carousel/ImageGalleryWithDialog";
import { sizeLabelMap } from "../../../../../../models/ProjectManagement/SizeMix";
import PopupGallery from "../../../../../../views/components/common/carousel/ImageGalleryDilog";

import InvoiceInformationPopup from "./InvoiceInformationPopup";
import { FilterValue } from "../../../../../../models/Filters/FilterValue";
import AppSearchDropdownMulti from "../../../../../../views/components/common/filter/AppSearchDropdownMulti";
import SkuVariantQtyList, { SkuQtyRow } from "./SkuVariantQtyList";
import InlineFormError from "./InlineFormError";
import SectionTaskStatus from "./SectionTaskStatus";
import SectionStageTiming from "./SectionStageTiming";
import CustomisationNotRequiredNotice from "./CustomisationNotRequiredNotice";
import QcStatusSummary from "./QcStatusSummary";
import QcProductQtyInputs from "./QcProductQtyInputs";
import { buildQcRequestFields, getQcSnapshot } from "./inventoryOpsQc";
import InventoryOpsActivityDrawer from "./InventoryOpsActivityDrawer";
import InventoryOpsReversalDialog, {
  formatRemovedQty,
} from "./InventoryOpsReversalDialog";
import { InventoryOpsActivityLogStore } from "../../../../stores/ProjectManagement/InventoryOpsActivityLogStore";
import InventoryOpsVariantTrackingSummary from "./InventoryOpsVariantTrackingSummary";
import ProductMetaChips from "../../../components/projects/ProductMetaChips";
import {
  isInventoryOpsPoTaskCompleted,
  InventoryOpsPoTaskKey,
  getProductRawInwardRemainingQty,
  getProductPrintInwardRemainingQty,
  getProductPrintOutwardRemainingQty,
} from "./inventoryOpsPoTaskStatus";
import {
  buildSelectedSkuLines,
  getPrintInwardQcSkuRows,
  getPrintInwardSkuRows,
  getPrintOutwardSkuRows,
  getRawInwardQcSkuRows,
  getRawInwardCountAtQcSkuRows,
  getPrintInwardCountAtQcSkuRows,
  getRawInwardSkuRows,
  hasSelectedPositiveQty,
  hasSelectedSkus,
  hasEnteredQtyForSelectedSkus,
  InventoryOpsSkuSectionKey,
} from "./inventoryOpsSkuRows";
import { EmployeeRoles } from "../../../../../../models/Employees/EmployeeRoles";

const FORM_ERRORS = {
  page: "page",
  rawInwardWarehouse: "rawInwardWarehouse",
  rawInwardQty: "rawInwardQty",
  rawInwardQc: "rawInwardQc",
  rawInwardQcQty: "rawInwardQcQty",
  rawInwardQcSave: "rawInwardQcSave",
  printOutwardPrinter: "printOutwardPrinter",
  printOutwardTimeline: "printOutwardTimeline",
  printOutwardQty: "printOutwardQty",
  printOutwardSave: "printOutwardSave",
  printInwardQty: "printInwardQty",
  printInwardQc: "printInwardQc",
  printInwardQcQty: "printInwardQcQty",
  printInwardQcSave: "printInwardQcSave",
  rawInwardCancel: "rawInwardCancel",
  rawInwardReceived: "rawInwardReceived",
  printInwardReceived: "printInwardReceived",
  printOutwardCancel: "printOutwardCancel",
  printInwardCancel: "printInwardCancel",
} as const;

type FormErrorKey = (typeof FORM_ERRORS)[keyof typeof FORM_ERRORS];

/**
 * Undo last / Revert / Cancel on each stage: `cancel` variant on a transparent
 * background. Disabled keeps a faded red instead of the default grey.
 */
const STAGE_ACTION_BUTTON_SX = (theme: Theme) => ({
  minHeight: "28px",
  px: 1.5,
  mb: 1,
  backgroundColor: "transparent",
  "&:hover": { backgroundColor: "transparent" },
  "&.Mui-disabled": {
    backgroundColor: "transparent",
    color: alpha(theme.palette.error.main, 0.5),
    border: `1px solid ${alpha(theme.palette.error.main, 0.35)}`,
  },
});

const createEmptySkuSelections = (): Record<
  InventoryOpsSkuSectionKey,
  Set<string>
> => ({
  rawInward: new Set(),
  rawInwardQc: new Set(),
  printOutward: new Set(),
  printInward: new Set(),
  printInwardQc: new Set(),
});

const buildQtyFieldsFromSelection = (
  rows: SkuQtyRow[],
  skuLines: InventoryOpsSkuVariantLine[] | null | undefined,
  selectedSkus: Set<string>,
  quantity: number | null | undefined,
  options?: { useRemaining?: boolean },
): InventoryOpsQtyFields => {
  const lines = buildSelectedSkuLines(rows, skuLines, selectedSkus, options);
  if (lines.length > 0) return { sku_variants: lines };
  return { quantity: quantity ?? 0 };
};

const InventoryOpsDetails: React.FC = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const projectId = Number(searchParams.get("project-id"));
  const productId = Number(searchParams.get("product-id"));
  const poIdFromUrl = Number(searchParams.get("po-id"));
  const theme = useTheme();
  // AppButton spreads customStyles into sx, so pass an object, not a theme callback.
  const stageActionButtonSx = STAGE_ACTION_BUTTON_SX(theme);
  const navigate = useNavigate();
  const { showSuccess, showError } = useNotification();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSummaryOpen, setSummaryOpen] = useState(false);
  const [isActivityOpen, setActivityOpen] = useState(false);
  const [activityStore] = useState(() => new InventoryOpsActivityLogStore());
  const [openQcPopup, setOpenQcPopup] = useState(false);
  const [openPrintQcPopup, setOpenPrintQcPopup] = useState(false);
  const [isInvoicePopupOpen, setIsInvoicePopupOpen] = useState<boolean>(false);
  const [selectedInwardId, setSelectedInwardId] = useState<
    number | null | undefined
  >(null);
  const [selectedInvoiceType, setSelectedInvoiceType] =
    useState<VendorInvoiceType | null>(null);
  const {
    projectInventoryOpsStore,
    shipmentStore,
    warehouseStore,
    userStore,
    orderStore,
    projectManagementStore,
  } = useStores();

  const [isPopupGalleryOpen, setIsPopupGalleryOpen] = useState(false);
  const [isPopupGalleryOpenForRawInward, setIsPopupGalleryOpenForRawInward] =
    useState(false);
  const [formErrors, setFormErrors] = useState<
    Partial<Record<FormErrorKey, string>>
  >({});
  const [skuSelections, setSkuSelections] = useState(createEmptySkuSelections);

  const toggleSkuSelection = (
    section: InventoryOpsSkuSectionKey,
    sku: string,
    selected: boolean,
  ) => {
    setSkuSelections((prev) => {
      const nextSet = new Set(prev[section]);
      if (selected) nextSet.add(sku);
      else nextSet.delete(sku);
      return { ...prev, [section]: nextSet };
    });
  };

  const setSkuSelectionBulk = (
    section: InventoryOpsSkuSectionKey,
    skus: string[],
    selected: boolean,
  ) => {
    setSkuSelections((prev) => {
      const nextSet = new Set(prev[section]);
      skus.forEach((sku) => {
        if (selected) nextSet.add(sku);
        else nextSet.delete(sku);
      });
      return { ...prev, [section]: nextSet };
    });
  };

  const clearSkuSelection = (section: InventoryOpsSkuSectionKey) => {
    setSkuSelections((prev) => ({
      ...prev,
      [section]: new Set(),
    }));
  };

  const setFieldError = (field: FormErrorKey, message: string) => {
    setFormErrors((prev) => ({ ...prev, [field]: message }));
  };

  const clearFieldError = (field: FormErrorKey) => {
    setFormErrors((prev) => {
      if (!prev[field]) return prev;
      const next = { ...prev };
      delete next[field];
      return next;
    });
  };

  const clearFieldErrors = (...fields: FormErrorKey[]) => {
    setFormErrors((prev) => {
      const next = { ...prev };
      let changed = false;
      fields.forEach((field) => {
        if (next[field]) {
          delete next[field];
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  };

  const getApiErrorMessage = (err: any, fallback: string) =>
    err?.response?.data?.message || fallback;

  useEffect(() => {
    document.body.classList.add("white-background");

    return () => {
      document.body.classList.remove("white-background");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchPoDetails = async (poId: number) => {
    try {
      await projectInventoryOpsStore.getProjectInventoryOpsProductDetailsForPurchaseOrder(
        projectId,
        Number(productId),
        poId,
      );
    } catch (err) {
      setFieldError(
        FORM_ERRORS.page,
        getApiErrorMessage(
          err,
          "Failed to fetch purchase order details, please try again later",
        ),
      );
      throw err;
    }
  };

  const fetchDetails = async () => {
    if (warehouseStore.warehouses.length === 0) {
      warehouseStore.searchWarehouse().catch((err) => {
        console.error(err);
      });
    }

    try {
      await projectInventoryOpsStore.getProjectInventoryOpsProductDetails(
        projectId,
        Number(productId),
      );

      const poIdFromUrl = Number(searchParams.get("po-id"));
      const allPOs =
        projectInventoryOpsStore.productDetailsBody.purchase_orders || [];
      const matchedPO = allPOs.find((po) => po.id === poIdFromUrl);
      const selectedPoId = matchedPO?.id ?? allPOs[0]?.id;

      if (!selectedPoId) {
        projectInventoryOpsStore.clearPoScopedDetails();
        return;
      }

      if (!matchedPO && allPOs.length > 0) {
        const params = new URLSearchParams(location.search);
        params.set("po-id", String(selectedPoId));
        navigate(`?${params.toString()}`, { replace: true });
      }

      await fetchPoDetails(selectedPoId);
    } catch (err) {
      setFieldError(
        FORM_ERRORS.page,
        getApiErrorMessage(err, "Failed to fetch data, please try again later"),
      );
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSummary = () => {
    setIsLoading(true);
    projectInventoryOpsStore
      .getSummary(projectId, Number(productId))
      .then((res) => {})
      .catch((err) => {
        setFieldError(
          FORM_ERRORS.page,
          getApiErrorMessage(
            err,
            "Failed to fetch data, please try again later",
          ),
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  /** Refresh button: reloads this screen in place, keeping the selected PO. */
  const handleRefresh = async () => {
    clearFieldError(FORM_ERRORS.page);
    try {
      const poId = await projectInventoryOpsStore.refreshData(
        projectId,
        Number(productId),
      );
      if (poId && poId !== poIdFromUrl) {
        const params = new URLSearchParams(location.search);
        params.set("po-id", String(poId));
        navigate(`?${params.toString()}`, { replace: true });
      }
    } catch (err) {
      setFieldError(
        FORM_ERRORS.page,
        getApiErrorMessage(err, "Failed to refresh, please try again later"),
      );
    }
  };

  const openActivity = () => {
    setActivityOpen(true);
    activityStore.setScope(
      projectId,
      Number(productId),
      projectInventoryOpsStore.currentPoDetails?.po_id ?? null,
    );
  };

  /** Refresh selected-PO SKU/inward detail + summary after inventory mutations. */
  const refreshAfterMutation = () => {
    const poId = projectInventoryOpsStore.currentPoDetails?.po_id;
    if (poId) {
      setIsLoading(true);
      fetchPoDetails(poId)
        .catch(() => undefined)
        .finally(() => {
          setIsLoading(false);
        });
    }
    projectInventoryOpsStore
      .getSummary(projectId, Number(productId))
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    setFormErrors({});
    setSkuSelections(createEmptySkuSelections());
  }, [productId, poIdFromUrl]);

  useEffect(() => {
    setIsLoading(true);

    if (projectId) {
      fetchSummary();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId]);
  useEffect(() => {
    setIsLoading(true);

    if (projectId) {
      fetchDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId]);
  useEffect(() => {
    getProjectInventoryOpsProduct(projectId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getProjectInventoryOpsProduct = (projectId: number) => {
    setIsLoading(true);
    projectInventoryOpsStore
      .getProjectInventoryOpsDetails(projectId)
      .finally(() => setIsLoading(false));
  };

  const handleNavigation = (direction: "back" | "forward") => {
    if (
      !projectInventoryOpsStore.inventoryRequestBody.products ||
      projectInventoryOpsStore.inventoryRequestBody.products.length === 0
    )
      return;

    const productList = projectInventoryOpsStore.inventoryRequestBody.products;
    const currentIndex = productList.findIndex(
      (product) => product.id === Number(productId),
    );

    if (currentIndex === -1) return;

    let newIndex = currentIndex;

    if (direction === "back") {
      newIndex = currentIndex > 0 ? currentIndex - 1 : productList.length - 1;
    } else {
      newIndex = currentIndex < productList.length - 1 ? currentIndex + 1 : 0;
    }

    const newProduct = productList[newIndex];

    navigate(
      `/projects/inventory-ops-details?project-id=${projectId}&product-id=${newProduct.id}`,
    );
  };

  const handleUpload1 = async (files: File[]) => {
    setIsLoading(true);
    if (files.length > 0) {
      try {
        projectInventoryOpsStore.updateCurrentPoDetails({
          temp_raw_inward_qc_images: [
            ...(projectInventoryOpsStore.currentPoDetails
              .temp_raw_inward_qc_images || []),
            ...files,
          ],
        });

        setOpenQcPopup(false);
      } catch (error) {
        setFieldError(
          FORM_ERRORS.rawInwardQcSave,
          "Something went wrong while uploading images. Please try again.",
        );
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  const handleUpload2 = async (files: File[]) => {
    setIsLoading(true);
    if (files.length > 0) {
      try {
        projectInventoryOpsStore.updateCurrentPoDetails({
          temp_print_inward_qc_images: [
            ...(projectInventoryOpsStore.currentPoDetails
              .temp_print_inward_qc_images || []),
            ...files,
          ],
        });
        setOpenPrintQcPopup(false);
      } catch (error) {
        setFieldError(
          FORM_ERRORS.printInwardQcSave,
          "Something went wrong while uploading images. Please try again.",
        );
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  const uploadImage = async (
    files: File[],
    category: string,
  ): Promise<string[]> => {
    if (files.length > 0) {
      const imageAPI = new ImageAPI();
      try {
        const uploadedUrls = await imageAPI.uploadImage(
          files,
          "product-images",
        );
        return uploadedUrls;
      } catch (err: any) {
        throw err;
      }
    }
    return [];
  };

  /**
   * Mark received without qty. countAtQc: true = count the stock in 1st QC
   * (tested qty), false = switch an uncounted inward back to qty entry.
   */
  const markRawInwardReceived = (countAtQc: boolean) => {
    const po = projectInventoryOpsStore.currentPoDetails;
    clearFieldErrors(
      FORM_ERRORS.rawInwardWarehouse,
      FORM_ERRORS.rawInwardReceived,
    );

    if (!po.warehouse_id) {
      setFieldError(
        FORM_ERRORS.rawInwardWarehouse,
        "Please select a warehouse first",
      );
      return;
    }

    const body: RawInwardReceivedReq = {
      order_id: projectId,
      product_id: Number(productId),
      po_id: po.po_id,
      mark_received: true,
      warehouse_id: String(po.warehouse_id),
      raw_inward_id: po.raw_inward_id ?? undefined,
      count_at_qc: countAtQc,
    };

    setIsLoading(true);
    projectInventoryOpsStore
      .markRawInwardReceived(body)
      .then(() => {
        refreshAfterMutation();
      })
      .catch((err) => {
        setFieldError(
          FORM_ERRORS.rawInwardReceived,
          getApiErrorMessage(
            err,
            "Failed to mark received, please try again later",
          ),
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const saveRawInwardQty = (options?: { useRemaining?: boolean }) => {
    const po = projectInventoryOpsStore.currentPoDetails;
    clearFieldErrors(FORM_ERRORS.rawInwardWarehouse, FORM_ERRORS.rawInwardQty);

    if (!po.warehouse_id) {
      setFieldError(
        FORM_ERRORS.rawInwardWarehouse,
        "Please select a warehouse first",
      );
      return;
    }

    if (
      rawInwardSkuRows.length > 0 &&
      !hasSelectedSkus(skuSelections.rawInward)
    ) {
      setFieldError(
        FORM_ERRORS.rawInwardQty,
        "Select at least one SKU to record quantity.",
      );
      return;
    }

    if (
      rawInwardSkuRows.length > 0 &&
      !options?.useRemaining &&
      !hasEnteredQtyForSelectedSkus(
        rawInwardSkuRows,
        po.temp_raw_inward_sku_variants,
        skuSelections.rawInward,
      )
    ) {
      setFieldError(
        FORM_ERRORS.rawInwardQty,
        "Enter quantity greater than 0 for at least one selected SKU.",
      );
      return;
    }

    // Product-level (no variants): remaining = ordered − (received − rejected).
    const productRemaining = getProductRawInwardRemainingQty(po, {
      customisationRequired: isCustomisationRequired,
    });
    if (rawInwardSkuRows.length === 0) {
      if (options?.useRemaining) {
        if (productRemaining <= 0) {
          setFieldError(
            FORM_ERRORS.rawInwardQty,
            "No remaining quantity to receive.",
          );
          return;
        }
      } else {
        const entered = po.temp_raw_inward_quantity ?? 0;
        if (entered <= 0) {
          setFieldError(
            FORM_ERRORS.rawInwardQty,
            "Enter quantity greater than 0.",
          );
          return;
        }
        if (entered > productRemaining) {
          setFieldError(
            FORM_ERRORS.rawInwardQty,
            `Quantity cannot exceed remaining (${productRemaining}).`,
          );
          return;
        }
      }
    }

    const qtyFields =
      rawInwardSkuRows.length === 0 && options?.useRemaining
        ? { quantity: productRemaining }
        : buildQtyFieldsFromSelection(
            rawInwardSkuRows,
            po.temp_raw_inward_sku_variants,
            skuSelections.rawInward,
            po.temp_raw_inward_quantity,
            options,
          );

    if (
      options?.useRemaining &&
      rawInwardSkuRows.length > 0 &&
      !hasSelectedPositiveQty(qtyFields.sku_variants || [])
    ) {
      if ((qtyFields.quantity ?? 0) <= 0) {
        setFieldError(
          FORM_ERRORS.rawInwardQty,
          "Selected SKUs have no remaining quantity to receive.",
        );
        return;
      }
    }

    const body: RawInwardQtyReq = {
      order_id: projectId,
      product_id: Number(productId),
      po_id: po.po_id,
      warehouse_id: po.warehouse_id ?? null,
      raw_inward_id: po.raw_inward_id ?? undefined,
      ...qtyFields,
    };

    setIsLoading(true);
    projectInventoryOpsStore
      .updateRawInwardQty(body)
      .then(() => {
        clearFieldError(FORM_ERRORS.rawInwardQty);
        clearSkuSelection("rawInward");
        refreshAfterMutation();
      })
      .catch((err) => {
        setFieldError(
          FORM_ERRORS.rawInwardQty,
          getApiErrorMessage(
            err,
            "Failed to save data, please try again later",
          ),
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  /** passRemaining = "Pass rest & close QC" / "Confirm QC". */
  const saveRawInwardQc = async (options?: { passRemaining?: boolean }) => {
    const po = projectInventoryOpsStore.currentPoDetails;
    clearFieldErrors(
      FORM_ERRORS.rawInwardQc,
      FORM_ERRORS.rawInwardQcQty,
      FORM_ERRORS.rawInwardQcSave,
    );

    if (!po.raw_inward_id) {
      setFieldError(
        FORM_ERRORS.rawInwardQc,
        "Raw inward is missing, please record raw inward first",
      );
      return;
    }

    const qcFields = buildQcRequestFields({
      rows: rawInwardQcSkuRows,
      skuLines: po.temp_raw_inward_qc_sku_variants,
      selectedSkus: skuSelections.rawInwardQc,
      productRejected: po.temp_raw_inward_rejection_quantity,
      productTested: po.temp_raw_inward_tested_quantity,
      checkableQty: rawQcCheckable,
      passRemaining: options?.passRemaining,
      countAtQc: rawQc.countAtQc,
    });
    if (!qcFields.ok) {
      setFieldError(FORM_ERRORS.rawInwardQcQty, qcFields.message);
      return;
    }

    const body: RawInwardQcReq = {
      order_id: projectId,
      product_id: Number(productId),
      po_id: po.po_id,
      raw_inward_id: po.raw_inward_id,
      ...qcFields.fields,
    };

    if (po.temp_raw_inward_rejection_reason) {
      body.rejection_reason = po.temp_raw_inward_rejection_reason;
    }

    setIsLoading(true);
    try {
      if (
        Array.isArray(po.temp_raw_inward_qc_images) &&
        po.temp_raw_inward_qc_images.length > 0
      ) {
        const uploadedImageUrls = await uploadImage(
          po.temp_raw_inward_qc_images,
          "products",
        );
        if (uploadedImageUrls.length > 0) {
          body.qc_images = uploadedImageUrls;
        }
      }

      await projectInventoryOpsStore.updateRawInwardQc(body);
      clearFieldError(FORM_ERRORS.rawInwardQcSave);
      clearSkuSelection("rawInwardQc");
      refreshAfterMutation();
    } catch (err: any) {
      setFieldError(
        FORM_ERRORS.rawInwardQcSave,
        getApiErrorMessage(err, "Failed to save data, please try again later"),
      );
    } finally {
      setIsLoading(false);
    }
  };

  const savePrintOutward = (options?: { useRemaining?: boolean }) => {
    const po = projectInventoryOpsStore.currentPoDetails;
    clearFieldErrors(
      FORM_ERRORS.printOutwardPrinter,
      FORM_ERRORS.printOutwardTimeline,
      FORM_ERRORS.printOutwardQty,
      FORM_ERRORS.printOutwardSave,
    );

    if (!po.temp_print_outward_timeline) {
      setFieldError(
        FORM_ERRORS.printOutwardTimeline,
        "Print due date is required",
      );
      return;
    }

    if (!po.temp_print_outward_printer_id) {
      setFieldError(FORM_ERRORS.printOutwardPrinter, "Please select a printer");
      return;
    }

    if (!po.raw_inward_id) {
      setFieldError(
        FORM_ERRORS.printOutwardSave,
        "Raw inward is missing, please record raw inward first",
      );
      return;
    }

    if (
      printOutwardSkuRows.length > 0 &&
      !hasSelectedSkus(skuSelections.printOutward)
    ) {
      setFieldError(
        FORM_ERRORS.printOutwardQty,
        "Select at least one SKU to send quantity.",
      );
      return;
    }

    if (
      printOutwardSkuRows.length > 0 &&
      !options?.useRemaining &&
      !hasEnteredQtyForSelectedSkus(
        printOutwardSkuRows,
        po.temp_print_outward_sku_variants,
        skuSelections.printOutward,
      )
    ) {
      setFieldError(
        FORM_ERRORS.printOutwardQty,
        "Enter quantity greater than 0 for at least one selected SKU.",
      );
      return;
    }

    const productRemaining = getProductPrintOutwardRemainingQty(po);
    if (printOutwardSkuRows.length === 0) {
      if (options?.useRemaining) {
        if (productRemaining <= 0) {
          setFieldError(
            FORM_ERRORS.printOutwardQty,
            "No remaining quantity to send. Complete 1st QC for newly inwarded qty first.",
          );
          return;
        }
      } else {
        const entered = po.temp_print_outward_quantity ?? 0;
        if (entered <= 0) {
          setFieldError(
            FORM_ERRORS.printOutwardQty,
            "Enter quantity greater than 0.",
          );
          return;
        }
        if (entered > productRemaining) {
          setFieldError(
            FORM_ERRORS.printOutwardQty,
            `Quantity cannot exceed remaining (${productRemaining}).`,
          );
          return;
        }
      }
    }

    const qtyFields =
      printOutwardSkuRows.length === 0 && options?.useRemaining
        ? { quantity: productRemaining }
        : buildQtyFieldsFromSelection(
            printOutwardSkuRows,
            po.temp_print_outward_sku_variants,
            skuSelections.printOutward,
            po.temp_print_outward_quantity,
            options,
          );

    if (
      options?.useRemaining &&
      printOutwardSkuRows.length > 0 &&
      !hasSelectedPositiveQty(qtyFields.sku_variants || [])
    ) {
      if ((qtyFields.quantity ?? 0) <= 0) {
        setFieldError(
          FORM_ERRORS.printOutwardQty,
          "Selected SKUs have no remaining quantity to send.",
        );
        return;
      }
    }

    const body: PrintOutwardReq = {
      order_id: projectId,
      product_id: Number(productId),
      po_id: po.po_id,
      raw_inward_id: po.raw_inward_id,
      printer_id: po.temp_print_outward_printer_id,
      print_outward_timeline: po.temp_print_outward_timeline,
      ...qtyFields,
    };

    setIsLoading(true);
    projectInventoryOpsStore
      .updatePrintOutward(body)
      .then(() => {
        clearFieldError(FORM_ERRORS.printOutwardSave);
        clearSkuSelection("printOutward");
        refreshAfterMutation();
      })
      .catch((err) => {
        setFieldError(
          FORM_ERRORS.printOutwardSave,
          getApiErrorMessage(
            err,
            "Failed to save data, please try again later",
          ),
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  /**
   * Mark printed goods received without qty. countAtQc: true = count them in
   * 2nd QC (tested qty), false = switch an uncounted inward back to qty entry.
   */
  const markPrintInwardReceived = (countAtQc: boolean) => {
    const po = projectInventoryOpsStore.currentPoDetails;
    clearFieldError(FORM_ERRORS.printInwardReceived);

    if (!po.print_outward_id) {
      setFieldError(
        FORM_ERRORS.printInwardReceived,
        "Print outward is missing, please record print outward first",
      );
      return;
    }

    const body: PrintInwardReceivedReq = {
      order_id: projectId,
      product_id: Number(productId),
      po_id: po.po_id,
      print_outward_id: po.print_outward_id,
      mark_received: true,
      print_inward_id: po.print_inward_id ?? undefined,
      count_at_qc: countAtQc,
    };

    setIsLoading(true);
    projectInventoryOpsStore
      .markPrintInwardReceived(body)
      .then(() => {
        refreshAfterMutation();
      })
      .catch((err) => {
        setFieldError(
          FORM_ERRORS.printInwardReceived,
          getApiErrorMessage(
            err,
            "Failed to mark received, please try again later",
          ),
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const savePrintInwardQty = (options?: { useRemaining?: boolean }) => {
    const po = projectInventoryOpsStore.currentPoDetails;
    clearFieldErrors(FORM_ERRORS.printInwardQty);

    if (!po.print_outward_id) {
      setFieldError(
        FORM_ERRORS.printInwardQty,
        "Print outward is missing, please record print outward first",
      );
      return;
    }

    if (
      printInwardSkuRows.length > 0 &&
      !hasSelectedSkus(skuSelections.printInward)
    ) {
      setFieldError(
        FORM_ERRORS.printInwardQty,
        "Select at least one SKU to record quantity.",
      );
      return;
    }

    if (
      printInwardSkuRows.length > 0 &&
      !options?.useRemaining &&
      !hasEnteredQtyForSelectedSkus(
        printInwardSkuRows,
        po.temp_print_inward_sku_variants,
        skuSelections.printInward,
      )
    ) {
      setFieldError(
        FORM_ERRORS.printInwardQty,
        "Enter quantity greater than 0 for at least one selected SKU.",
      );
      return;
    }

    // Product-level (no variants): remaining = sent − (received − rejected).
    const productRemaining = getProductPrintInwardRemainingQty(po);
    if (printInwardSkuRows.length === 0) {
      if (options?.useRemaining) {
        if (productRemaining <= 0) {
          setFieldError(
            FORM_ERRORS.printInwardQty,
            "No remaining quantity to receive.",
          );
          return;
        }
      } else {
        const entered = po.temp_print_inward_quantity ?? 0;
        if (entered <= 0) {
          setFieldError(
            FORM_ERRORS.printInwardQty,
            "Enter quantity greater than 0.",
          );
          return;
        }
        if (entered > productRemaining) {
          setFieldError(
            FORM_ERRORS.printInwardQty,
            `Quantity cannot exceed remaining (${productRemaining}).`,
          );
          return;
        }
      }
    }

    const qtyFields =
      printInwardSkuRows.length === 0 && options?.useRemaining
        ? { quantity: productRemaining }
        : buildQtyFieldsFromSelection(
            printInwardSkuRows,
            po.temp_print_inward_sku_variants,
            skuSelections.printInward,
            po.temp_print_inward_quantity,
            options,
          );

    if (
      options?.useRemaining &&
      printInwardSkuRows.length > 0 &&
      !hasSelectedPositiveQty(qtyFields.sku_variants || [])
    ) {
      if ((qtyFields.quantity ?? 0) <= 0) {
        setFieldError(
          FORM_ERRORS.printInwardQty,
          "Selected SKUs have no remaining quantity to receive.",
        );
        return;
      }
    }

    const body: PrintInwardQtyReq = {
      order_id: projectId,
      product_id: Number(productId),
      po_id: po.po_id,
      print_outward_id: po.print_outward_id,
      print_inward_id: po.print_inward_id ?? undefined,
      ...qtyFields,
    };

    setIsLoading(true);
    projectInventoryOpsStore
      .updatePrintInwardQty(body)
      .then(() => {
        clearFieldError(FORM_ERRORS.printInwardQty);
        clearSkuSelection("printInward");
        refreshAfterMutation();
      })
      .catch((err) => {
        setFieldError(
          FORM_ERRORS.printInwardQty,
          getApiErrorMessage(
            err,
            "Failed to save data, please try again later",
          ),
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  /** passRemaining = "Pass rest & close QC" / "Confirm QC". */
  const savePrintInwardQc = async (options?: { passRemaining?: boolean }) => {
    const po = projectInventoryOpsStore.currentPoDetails;
    clearFieldErrors(
      FORM_ERRORS.printInwardQc,
      FORM_ERRORS.printInwardQcQty,
      FORM_ERRORS.printInwardQcSave,
    );

    if (!po.print_inward_id) {
      setFieldError(
        FORM_ERRORS.printInwardQc,
        "Print inward is missing, please record print inward first",
      );
      return;
    }

    const qcFields = buildQcRequestFields({
      rows: printInwardQcSkuRows,
      skuLines: po.temp_print_inward_qc_sku_variants,
      selectedSkus: skuSelections.printInwardQc,
      productRejected: po.temp_print_inward_rejection_quantity,
      productTested: po.temp_print_inward_tested_quantity,
      checkableQty: printQcCheckable,
      passRemaining: options?.passRemaining,
      countAtQc: printQc.countAtQc,
    });
    if (!qcFields.ok) {
      setFieldError(FORM_ERRORS.printInwardQcQty, qcFields.message);
      return;
    }

    const body: PrintInwardQcReq = {
      order_id: projectId,
      product_id: Number(productId),
      po_id: po.po_id,
      print_inward_id: po.print_inward_id,
      ...qcFields.fields,
    };

    if (po.temp_print_inward_rejection_reason) {
      body.rejection_reason = po.temp_print_inward_rejection_reason;
    }

    setIsLoading(true);
    try {
      if (
        Array.isArray(po.temp_print_inward_qc_images) &&
        po.temp_print_inward_qc_images.length > 0
      ) {
        const uploadedImageUrls = await uploadImage(
          po.temp_print_inward_qc_images,
          "products",
        );
        if (uploadedImageUrls.length > 0) {
          body.qc_images = uploadedImageUrls;
        }
      }

      await projectInventoryOpsStore.updatePrintInwardQc(body);
      clearFieldError(FORM_ERRORS.printInwardQcSave);
      clearSkuSelection("printInwardQc");
      refreshAfterMutation();
    } catch (err: any) {
      setFieldError(
        FORM_ERRORS.printInwardQcSave,
        getApiErrorMessage(err, "Failed to save data, please try again later"),
      );
    } finally {
      setIsLoading(false);
    }
  };

  const canCancelInwards = userStore.hasPermission(
    EmployeeRoles.CANCEL_INWARDS,
  );

  // Undo / revert: same admins who can inward. Not supported on Swageazy inventory PRs.
  const canReverseInwards =
    projectId !== -1 && userStore.hasPermission(EmployeeRoles.VIEW_ORDER);

  const [reversalTarget, setReversalTarget] = useState<{
    stage: InventoryOpsReversalStage;
    action: InventoryOpsReversalAction;
  } | null>(null);
  const [reversalSuccess, setReversalSuccess] = useState<
    Partial<Record<InventoryOpsReversalStage, string>>
  >({});

  const currentPoId = projectInventoryOpsStore.currentPoDetails?.po_id;
  useEffect(() => {
    setReversalTarget(null);
    setReversalSuccess({});
  }, [currentPoId]);

  /** Record id, current qty, undo flag and count-at-QC mode per stage. */
  const getReversalStageState = (stage: InventoryOpsReversalStage) => {
    const po = projectInventoryOpsStore.currentPoDetails;
    switch (stage) {
      case "raw-inward":
        return {
          recordId: po?.raw_inward_id ?? null,
          qty: Number(po?.raw_inward_quantity) || 0,
          undoAvailable: Boolean(po?.raw_inward_undo_available),
          countAtQc: po?.raw_inward_qty_source === "QC",
        };
      case "print-outward":
        return {
          recordId: po?.print_outward_id ?? null,
          qty: Number(po?.print_outward_quantity) || 0,
          undoAvailable: Boolean(po?.print_outward_undo_available),
          countAtQc: false,
        };
      default:
        return {
          recordId: po?.print_inward_id ?? null,
          qty: Number(po?.print_inward_quantity) || 0,
          undoAvailable: Boolean(po?.print_inward_undo_available),
          countAtQc: po?.print_inward_qty_source === "QC",
        };
    }
  };

  const openReversalDialog = (
    stage: InventoryOpsReversalStage,
    action: InventoryOpsReversalAction,
  ) => {
    setReversalSuccess((prev) => ({ ...prev, [stage]: undefined }));
    setReversalTarget({ stage, action });
  };

  /** Throws with the server message so the dialog can show it as-is. */
  const confirmReversal = async (reason: string) => {
    if (!reversalTarget) return;
    const { stage, action } = reversalTarget;
    const po = projectInventoryOpsStore.currentPoDetails;
    const { recordId } = getReversalStageState(stage);
    if (!recordId || !po?.po_id) {
      throw new Error("No active record found for this PO.");
    }
    if (!reason) {
      throw new Error("A reason is required.");
    }

    const base = {
      order_id: projectId,
      product_id: Number(productId),
      po_id: po.po_id,
      reason,
    };
    const body: InventoryOpsReversalReq =
      stage === "raw-inward"
        ? { ...base, raw_inward_id: recordId }
        : stage === "print-outward"
          ? { ...base, print_outward_id: recordId }
          : { ...base, print_inward_id: recordId };

    const removed = await projectInventoryOpsStore.reverseInventoryOpsStage(
      stage,
      action,
      body,
    );
    setReversalSuccess((prev) => ({
      ...prev,
      [stage]: formatRemovedQty(stage, action, removed),
    }));
    setReversalTarget(null);
    refreshAfterMutation();
  };

  const renderReversalButtons = (
    stage: InventoryOpsReversalStage,
    locked: boolean,
  ) => {
    if (!canReverseInwards) return null;
    const { recordId, qty, undoAvailable } = getReversalStageState(stage);
    if (!recordId) return null;
    return (
      <>
        {undoAvailable && (
          <AppButton
            label="Undo last"
            onClick={() => openReversalDialog(stage, "undo-last")}
            variant="cancel"
            disabled={locked}
            fontSize="0.7rem"
            customStyles={stageActionButtonSx}
          />
        )}
        {qty > 0 && (
          <AppButton
            label="Revert"
            onClick={() => openReversalDialog(stage, "revert")}
            variant="cancel"
            disabled={locked}
            fontSize="0.7rem"
            customStyles={stageActionButtonSx}
          />
        )}
      </>
    );
  };

  const renderReversalSuccess = (stage: InventoryOpsReversalStage) =>
    reversalSuccess[stage] ? (
      <CustomTypography
        variant="heading8"
        color={theme.palette.customColors.successGreen}
        style={{ display: "block", fontSize: "0.75rem", marginBottom: 8 }}
      >
        {reversalSuccess[stage]}
      </CustomTypography>
    ) : null;

  const cancelRawInward = async () => {
    const po = projectInventoryOpsStore.currentPoDetails;
    clearFieldError(FORM_ERRORS.rawInwardCancel);

    if (!po.raw_inward_id) {
      setFieldError(
        FORM_ERRORS.rawInwardCancel,
        "No raw inward record found to cancel.",
      );
      return;
    }

    if (po.print_outward_id) {
      setFieldError(
        FORM_ERRORS.rawInwardCancel,
        "Cannot cancel raw inward while print outward is active.",
      );
      return;
    }

    if (po.print_inward_id) {
      setFieldError(
        FORM_ERRORS.rawInwardCancel,
        "Cannot cancel raw inward while print inward is active.",
      );
      return;
    }

    const body: RawInwardCancelReq = {
      order_id: projectId,
      product_id: Number(productId),
      raw_inward_id: po.raw_inward_id,
      po_id: po.po_id,
    };

    setIsLoading(true);
    projectInventoryOpsStore
      .cancelRawInward(body)
      .then(() => {
        clearFieldError(FORM_ERRORS.rawInwardCancel);
        refreshAfterMutation();
      })
      .catch((err) => {
        setFieldError(
          FORM_ERRORS.rawInwardCancel,
          getApiErrorMessage(
            err,
            "Failed to cancel raw inward, please try again later",
          ),
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const cancelPrintOutward = async () => {
    const po = projectInventoryOpsStore.currentPoDetails;
    clearFieldError(FORM_ERRORS.printOutwardCancel);

    if (!po.print_outward_id) {
      setFieldError(
        FORM_ERRORS.printOutwardCancel,
        "No print outward record found to cancel.",
      );
      return;
    }

    if (po.print_inward_id) {
      setFieldError(
        FORM_ERRORS.printOutwardCancel,
        "Cannot cancel print outward while print inward is active.",
      );
      return;
    }

    const body: PrintOutwardCancelReq = {
      order_id: projectId,
      product_id: Number(productId),
      print_outward_id: po.print_outward_id,
      po_id: po.po_id,
    };

    setIsLoading(true);
    projectInventoryOpsStore
      .cancelPrintOutward(body)
      .then(() => {
        clearFieldError(FORM_ERRORS.printOutwardCancel);
        refreshAfterMutation();
      })
      .catch((err) => {
        setFieldError(
          FORM_ERRORS.printOutwardCancel,
          getApiErrorMessage(
            err,
            "Failed to cancel print outward, please try again later",
          ),
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const cancelPrintInward = async () => {
    const po = projectInventoryOpsStore.currentPoDetails;
    clearFieldError(FORM_ERRORS.printInwardCancel);

    if (!po.print_inward_id) {
      setFieldError(
        FORM_ERRORS.printInwardCancel,
        "No print inward record found to cancel.",
      );
      return;
    }

    const body: PrintInwardCancelReq = {
      order_id: projectId,
      product_id: Number(productId),
      print_inward_id: po.print_inward_id,
      po_id: po.po_id,
    };

    setIsLoading(true);
    projectInventoryOpsStore
      .cancelPrintInward(body)
      .then(() => {
        clearFieldError(FORM_ERRORS.printInwardCancel);
        refreshAfterMutation();
      })
      .catch((err) => {
        setFieldError(
          FORM_ERRORS.printInwardCancel,
          getApiErrorMessage(
            err,
            "Failed to cancel print inward, please try again later",
          ),
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSaveInvoiceDetails = async (
    inwardId: number,
    type: VendorInvoiceType,
    invoiceReceived: boolean,
    invoices?: VendorInvoice[],
  ) => {
    try {
      if (inwardId && type) {
        await Promise.all([
          projectInventoryOpsStore.updateInvoiceMarkedAsReceived(
            inwardId,
            type,
            invoiceReceived,
          ),
          projectInventoryOpsStore.addUpdateVendorInvoices(
            inwardId,
            type,
            invoices ?? [],
          ),
        ]);
        showSuccess(
          `Invoice marked as ${
            invoiceReceived ? "received" : "not received"
          } successfully! Invoice(s) saved successfully!`,
        );
      } else {
        showSuccess(
          `Invoice marked as ${
            invoiceReceived ? "received" : "not received"
          } successfully!`,
        );
      }
      setIsInvoicePopupOpen(false);
    } catch (error: any) {
      showError(
        "Error Occurred",
        error.response.data.message ||
          "Failed to save invoice details, please try again later",
      );
    }
  };

  const fetchVendorInvoices = (
    inwardId: number | null | undefined,
    type: VendorInvoiceType,
  ) => {
    if (inwardId && type) {
      projectInventoryOpsStore
        .fetchVendorInvoices(inwardId, type)
        .then(() => {
          handleOpenInvoicePopup(inwardId, type);
        })
        .catch((err) => {
          showError(
            "Error Occurred",
            err.response.data.message ||
              "Failed to fetch invoices, please try again later",
          );
        });
    }
  };

  const handleOpenInvoicePopup = (
    inwardId: number,
    type: VendorInvoiceType,
  ) => {
    setSelectedInwardId(inwardId);
    setSelectedInvoiceType(type);
    setIsInvoicePopupOpen(true);
  };

  const handleCloseInvoicePopup = () => {
    setIsInvoicePopupOpen(false);
  };

  const currentPoDetails = projectInventoryOpsStore.currentPoDetails;
  const sizeMixes = projectInventoryOpsStore.poDetailsBody?.size_mixes;
  const isPodOrder = isPodOrderType(
    orderStore.orderBasicDetails?.type_id ??
      projectManagementStore.currentProjectDetails?.order_type_id,
  );
  const isArchived =
    isPodOrder ||
    projectInventoryOpsStore.inventoryRequestBody.archived === 1;
  const isCustomisationRequired = Boolean(
    projectInventoryOpsStore.productDetailsBody?.product
      ?.customisation_required,
  );

  const rawQc = getQcSnapshot(currentPoDetails, "raw");
  const printQc = getQcSnapshot(currentPoDetails, "print");

  const rawInwardSkuRows = getRawInwardSkuRows(sizeMixes, currentPoDetails);
  // Count at QC lists every ordered SKU; tested is added to received.
  const rawInwardQcSkuRows = rawQc.countAtQc
    ? getRawInwardCountAtQcSkuRows(sizeMixes, currentPoDetails)
    : getRawInwardQcSkuRows(sizeMixes, currentPoDetails);
  const printOutwardSkuRows = getPrintOutwardSkuRows(
    sizeMixes,
    currentPoDetails,
  );
  const printInwardSkuRows = getPrintInwardSkuRows(sizeMixes, currentPoDetails);
  // Count at QC lists every SKU sent to the printer.
  const printInwardQcSkuRows = printQc.countAtQc
    ? getPrintInwardCountAtQcSkuRows(sizeMixes, currentPoDetails)
    : getPrintInwardQcSkuRows(sizeMixes, currentPoDetails);

  // Tracked raw QC: only passed qty can go to the printer.
  const isPrintOutwardAwaitingQc =
    rawQc.tracked &&
    (rawQc.passed ?? 0) - (currentPoDetails?.print_outward_quantity ?? 0) <= 0;

  const poTaskCompleted = (task: InventoryOpsPoTaskKey) =>
    isInventoryOpsPoTaskCompleted(
      task,
      projectInventoryOpsStore.currentPoDetails,
      sizeMixes,
      { customisationRequired: isCustomisationRequired },
    );

  const isRawInwardLocked = isArchived || poTaskCompleted("raw_inward");
  const isWarehouseLockedFromPo =
    projectInventoryOpsStore.isWarehouseLockedFromPo;
  const isWarehouseSelectionDisabled =
    isRawInwardLocked || isWarehouseLockedFromPo;

  const selectedWarehouseId =
    projectInventoryOpsStore.currentPoDetails?.warehouse_id || undefined;
  const selectedWarehouseLabel = (() => {
    if (!selectedWarehouseId) return "";
    const matchedWarehouse = warehouseStore.warehouses?.find(
      (warehouse) => String(warehouse.id) === String(selectedWarehouseId),
    );
    return (
      matchedWarehouse?.identifier ||
      projectInventoryOpsStore.currentPoDetails?.warehouse_identifier ||
      String(selectedWarehouseId)
    );
  })();

  // A qty inward with no qty yet cannot be tested (API returns 400).
  const isRawInwardQcLocked =
    isArchived || rawQc.awaitingQty || poTaskCompleted("raw_inward_qc");
  const isPrintOutwardLocked =
    isArchived || !isCustomisationRequired || poTaskCompleted("print_outward");
  const isPrintInwardLocked =
    isArchived || !isCustomisationRequired || poTaskCompleted("print_inward");
  // A qty inward with no qty yet cannot be tested (API returns 400).
  const isPrintInwardQcLocked =
    isArchived ||
    !isCustomisationRequired ||
    printQc.awaitingQty ||
    poTaskCompleted("print_inward_qc");

  const productRawInwardRemaining = getProductRawInwardRemainingQty(
    currentPoDetails,
    { customisationRequired: isCustomisationRequired },
  );
  // Count at QC: tested is capped at what is still to receive.
  const rawQcCheckable = rawQc.countAtQc
    ? productRawInwardRemaining
    : rawQc.checkable;
  // Qty for a count-at-QC inward comes from QC; /raw-inward/qty returns 400.
  const isRawInwardCountedAtQc = rawQc.countAtQc;
  const isRawInwardQtyLocked = isRawInwardLocked || isRawInwardCountedAtQc;
  // count_at_qc can only be switched while nothing has been counted yet.
  const canSwitchRawInwardMode =
    (currentPoDetails?.raw_inward_quantity ?? 0) <= 0;
  const productPrintOutwardRemaining =
    getProductPrintOutwardRemainingQty(currentPoDetails);
  const productPrintInwardRemaining =
    getProductPrintInwardRemainingQty(currentPoDetails);
  // Count at QC: tested is capped at what can still come back from print.
  const printQcCheckable = printQc.countAtQc
    ? productPrintInwardRemaining
    : printQc.checkable;
  // Qty for a count-at-QC print inward comes from QC; /print-inward/qty is 400.
  const isPrintInwardCountedAtQc = printQc.countAtQc;
  const isPrintInwardQtyLocked =
    isPrintInwardLocked || isPrintInwardCountedAtQc;
  const canSwitchPrintInwardMode =
    Boolean(currentPoDetails?.print_outward_id) &&
    (currentPoDetails?.print_outward_quantity ?? 0) > 0 &&
    (currentPoDetails?.print_inward_quantity ?? 0) <= 0;
  const productRawInwardNet = Math.max(
    0,
    (currentPoDetails?.raw_inward_quantity ?? 0) -
      (currentPoDetails?.raw_inward_rejection_quantity ?? 0),
  );
  const productPrintInwardNet = Math.max(
    0,
    (currentPoDetails?.print_inward_quantity ?? 0) -
      (currentPoDetails?.print_inward_rejection_quantity ?? 0),
  );

  // Raw inward can be cancelled for non-customisable products too; only an
  // active print outward blocks it.
  const isRawInwardCancelLocked =
    isArchived ||
    (projectInventoryOpsStore.currentPoDetails?.print_outward_id !== null &&
      projectInventoryOpsStore.currentPoDetails?.print_outward_id !==
        undefined);
  const isPrintOutCancelLocked =
    isArchived ||
    !isCustomisationRequired ||
    (projectInventoryOpsStore.currentPoDetails?.print_inward_id !== null &&
      projectInventoryOpsStore.currentPoDetails?.print_inward_id !== undefined);
  const isPrintInwardCancelLocked = isArchived || !isCustomisationRequired;

  return (
    <>
      <Backdrop
        sx={(theme) => ({
          color: theme.palette.customColors.white,
          zIndex: theme.zIndex.drawer + 1,
        })}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
        <Box sx={{ margin: "auto", mb: 1 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              cursor: "pointer",
              color: theme.palette.customColors.greyTextColor,
              mb: 1,
              mt: 1,
              maxWidth: "3.75rem",
              paddingLeft: { xl: 3.2, lg: 3.2, md: 3.2, sm: 0, xs: 0 },
              "&:hover, &:active": {
                color: theme.palette.customColors.greyTextColor,
              },
            }}
            onClick={() => {
              navigate(`/projects/${projectId}?tab_index=2`);
            }}
          >
            <ArrowBackIcon sx={{ fontSize: "1rem" }} />
            <span style={{ fontSize: "0.875rem", fontWeight: "600" }}>
              Back
            </span>
          </Box>

          <InlineFormError
            message={formErrors[FORM_ERRORS.page]}
            sx={{ mb: 2 }}
          />
          {isPodOrder ? <PodProjectOpsDisabledBanner /> : null}

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              position: "relative",
              width: "100%",
              gap: "10px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "@media (max-width: 900px)": {
                  display: "none",
                },
              }}
            >
              <IconButton
                onClick={() => handleNavigation("back")}
                disabled={
                  projectInventoryOpsStore.checkProductIndex(
                    Number(productId),
                  ) === 0
                }
                sx={{
                  mt: 0,
                  ml: { xs: "-26px", lg: "-26px", md: "-26px" },
                  border: `2px solid ${theme.palette.customColors.disabledBorderColor}`,
                  width: "35px",
                  height: "35px",
                  display: { xs: "flex", md: "inline-flex" },
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ArrowBackIosIcon
                  sx={{ fontSize: { xs: "1rem", md: "1rem", sm: "1rem" } }}
                  style={{ marginLeft: "4px" }}
                />
              </IconButton>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                flexGrow: 1,
              }}
            >
              <Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <CustomTypography
                    variant="heading2"
                    color={theme.palette.customColors.greyTextColor}
                  >
                    #{projectId}
                  </CustomTypography>
                  {projectInventoryOpsStore?.inventoryRequestBody?.label && (
                    <Chip
                      label={
                        projectInventoryOpsStore.inventoryRequestBody.label
                      }
                      size="small"
                      sx={{ pl: 2, pr: 2, fontSize: "12px" }}
                    />
                  )}
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mt: 0.5,
                  }}
                >
                  <Box>
                    <CustomTypography variant="heading2">
                      {
                        projectInventoryOpsStore.productDetailsBody.product
                          ?.name
                      }
                    </CustomTypography>
                    <ProductMetaChips
                      quantity={
                        projectInventoryOpsStore.productDetailsBody.product
                          ?.quantity
                      }
                      productId={
                        productId ||
                        projectInventoryOpsStore.productDetailsBody.product?.id
                      }
                    />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mt: 0.5,
                      }}
                    >
                      <CustomTypography
                        variant="heading7"
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ marginRight: 1 }}>
                          <img
                            src={vendorIcon}
                            alt="Raw Inward Icon"
                            style={{ width: 24, height: 24 }}
                          />
                        </Box>
                        Vendor:
                        <span
                          style={{
                            color: theme.palette.customColors.greyDarkborder,
                            paddingLeft: 5,
                          }}
                        >
                          {projectInventoryOpsStore.currentPoDetails
                            ?.vendor_name || ""}
                        </span>
                      </CustomTypography>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{ paddingTop: 0 }}>
                <CustomTypography
                  variant="heading7"
                  style={{ marginBottom: 4 }}
                  color={theme.palette.customColors.greyTextColor}
                >
                  Progress
                </CustomTypography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <LinearProgress
                    variant="determinate"
                    value={projectInventoryOpsStore.poDetailsBody.progress || 0}
                    sx={{
                      height: 10,
                      width: 200,
                      borderRadius: 5,
                      backgroundColor:
                        theme.palette.customColors.grayBackGroundColor,
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: theme.palette.customColors.purple,
                      },
                    }}
                  />
                  <CustomTypography
                    variant="heading7"
                    color={theme.palette.customColors.greyTextColor}
                  >
                    {projectInventoryOpsStore.poDetailsBody.progress}%{" "}
                  </CustomTypography>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "@media (max-width: 900px)": {
                  display: "none",
                },
              }}
            >
              <IconButton
                onClick={() => handleNavigation("forward")}
                disabled={
                  projectInventoryOpsStore.checkProductIndex(
                    Number(productId),
                  ) ===
                  projectInventoryOpsStore.inventoryRequestBody.products
                    ?.length -
                    1
                }
                sx={{
                  mt: 0,
                  border: `2px solid ${theme.palette.customColors.disabledBorderColor}`,
                  width: "35px",
                  height: "35px",
                  display: { xs: "flex", md: "inline-flex" },
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ArrowForwardIosIcon
                  sx={{ fontSize: { xs: "1rem", md: "1rem", sm: "1rem" } }}
                  style={{ marginLeft: "2px" }}
                />
              </IconButton>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mt: 0.75,
              pl: { xl: "1.8rem", lg: "1.8rem", md: "1.8rem" },
            }}
          >
            {projectInventoryOpsStore.currentPoDetails?.raw_inward_id && (
              <CustomTypography
                variant="heading8"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Raw Inward -
                <span
                  style={{
                    color: theme.palette.customColors.greyDarkborder,
                    paddingLeft: 5,
                  }}
                >
                  {projectInventoryOpsStore.currentPoDetails.raw_inward_id +
                    " |"}
                </span>
              </CustomTypography>
            )}

            {projectInventoryOpsStore.currentPoDetails?.print_outward_id && (
              <CustomTypography
                variant="heading8"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Print Outward -
                <span
                  style={{
                    color: theme.palette.customColors.greyDarkborder,
                    paddingLeft: 5,
                  }}
                >
                  {projectInventoryOpsStore.currentPoDetails.print_outward_id +
                    " |"}
                </span>
              </CustomTypography>
            )}

            {projectInventoryOpsStore.currentPoDetails?.print_inward_id && (
              <CustomTypography
                variant="heading8"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Print Inward -
                <span
                  style={{
                    color: theme.palette.customColors.greyDarkborder,
                    paddingLeft: 5,
                  }}
                >
                  {projectInventoryOpsStore.currentPoDetails.print_inward_id}
                </span>
              </CustomTypography>
            )}
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              "@media (min-width: 900px)": {
                display: "none",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <IconButton
                onClick={() => handleNavigation("back")}
                disabled={
                  projectInventoryOpsStore.checkProductIndex(
                    Number(productId),
                  ) === 0
                }
                sx={{
                  mt: 1,
                  ml: { xs: "-26px", lg: "-26px", md: "-26px" },
                  border: `2px solid ${theme.palette.customColors.disabledBorderColor}`,
                  width: "35px",
                  height: "35px",
                  display: { xs: "flex", md: "inline-flex" },
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ArrowBackIosIcon
                  sx={{ fontSize: { xs: "1rem", md: "1rem", sm: "1rem" } }}
                  style={{ marginLeft: "4px" }}
                />
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <IconButton
                onClick={() => handleNavigation("forward")}
                disabled={
                  projectInventoryOpsStore.checkProductIndex(
                    Number(productId),
                  ) ===
                  projectInventoryOpsStore.inventoryRequestBody.products
                    ?.length -
                    1
                }
                sx={{
                  mt: 1,
                  border: `2px solid ${theme.palette.customColors.disabledBorderColor}`,
                  width: "35px",
                  height: "35px",
                  display: { xs: "flex", md: "inline-flex" },
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ArrowForwardIosIcon
                  sx={{ fontSize: { xs: "1rem", md: "1rem", sm: "1rem" } }}
                  style={{ marginLeft: "2px" }}
                />
              </IconButton>
            </Box>
          </Box>
        </Box>

        <Box sx={{ margin: "auto" }} pl={3} pr={3}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: 2,
                maxWidth: "70%",
                overflowX: "auto",
                whiteSpace: "nowrap",
                scrollbarWidth: "none",
              }}
            >
              {projectInventoryOpsStore.productDetailsBody.purchase_orders?.map(
                (po) => (
                  <Box
                    key={po.id}
                    onClick={() => {
                      if (
                        projectInventoryOpsStore.currentPoDetails?.po_id ===
                        po.id
                      ) {
                        return;
                      }
                      setFormErrors({});
                      const params = new URLSearchParams(location.search);
                      params.set("po-id", String(po.id));
                      navigate(`?${params.toString()}`, { replace: true });
                      setIsLoading(true);
                      fetchPoDetails(po.id)
                        .catch(() => undefined)
                        .finally(() => {
                          setIsLoading(false);
                        });
                    }}
                    sx={{
                      cursor: "pointer",
                      minWidth: "6rem",
                      textAlign: "center",
                      borderBottom:
                        projectInventoryOpsStore.currentPoDetails?.po_id ===
                        po.id
                          ? `2px solid ${theme.palette.customColors.purple}`
                          : "none",
                      paddingBottom: "0.35rem",
                    }}
                  >
                    <CustomTypography
                      variant="heading5"
                      style={{
                        color:
                          projectInventoryOpsStore.currentPoDetails?.po_id ===
                          po.id
                            ? theme.palette.customColors.purple
                            : "black",
                      }}
                    >
                      PO: {po.id}
                    </CustomTypography>
                  </Box>
                ),
              )}
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
              <Box onClick={handleRefresh} sx={{ cursor: "pointer" }}>
                <CustomTypography
                  variant="heading6"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    color: theme.palette.customColors.pinkDark,
                  }}
                >
                  <RefreshIcon sx={{ fontSize: "1.25rem" }} />
                  Refresh
                </CustomTypography>
              </Box>
              <Box onClick={openActivity} sx={{ cursor: "pointer" }}>
                <CustomTypography
                  variant="heading6"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    color: theme.palette.customColors.pinkDark,
                  }}
                >
                  <HistoryIcon sx={{ fontSize: "1.25rem" }} />
                  Activity
                </CustomTypography>
              </Box>
              {reversalTarget && (
                <InventoryOpsReversalDialog
                  open
                  stage={reversalTarget.stage}
                  action={reversalTarget.action}
                  currentQty={getReversalStageState(reversalTarget.stage).qty}
                  countAtQc={
                    getReversalStageState(reversalTarget.stage).countAtQc
                  }
                  onClose={() => setReversalTarget(null)}
                  onConfirm={confirmReversal}
                />
              )}
              <InventoryOpsActivityDrawer
                open={isActivityOpen}
                onClose={() => setActivityOpen(false)}
                store={activityStore}
                showPrintStages={isCustomisationRequired}
                onRefreshMain={handleRefresh}
                isMainRefreshing={projectInventoryOpsStore.isRefreshing}
              />
              <Box
                onClick={() => setSummaryOpen(true)}
                sx={{ cursor: "pointer" }}
              >
                <CustomTypography
                  variant="heading6"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    color: theme.palette.customColors.grayText,
                  }}
                >
                  <HistoryIcon sx={{ fontSize: "1.25rem" }} />
                  Summary
                </CustomTypography>
              </Box>
              <SummaryDrawer
                isOpen={isSummaryOpen}
                onClose={() => setSummaryOpen(false)}
                summaryData={
                  Array.isArray(projectInventoryOpsStore.summaryDetails)
                    ? projectInventoryOpsStore.summaryDetails
                    : [projectInventoryOpsStore.summaryDetails]
                }
              />
            </Box>
          </Box>

          <>
            <Divider sx={{ mb: 2 }} />

            <InventoryOpsVariantTrackingSummary
              sizeMixes={sizeMixes}
              po={currentPoDetails}
              showPrintColumns={isCustomisationRequired}
            />

            <Grid2
              container
              spacing={{ lg: 4, xs: 2 }}
              columns={{ lg: 12, xs: 12 }}
              sx={{
                display: { xl: "flex", lg: "flex", md: "block" },
                justifyContent: { xl: "space-between", lg: "space-between" },
              }}
            >
              <Grid2 size={{ xl: 4.3, lg: 5, md: 12, xs: 12 }}>
                {projectInventoryOpsStore.productDetailsBody ? (
                  <Box>
                    <CustomTypography variant="heading5">
                      Product Images
                    </CustomTypography>

                    <ImageCarousel
                      images={
                        projectInventoryOpsStore.productDetails?.product
                          ?.image_urls
                          ? projectInventoryOpsStore.productDetails?.product
                              ?.image_urls
                          : projectInventoryOpsStore.productDetails?.product
                              ?.image_url
                      }
                    />
                  </Box>
                ) : (
                  <Box>
                    <CustomTypography variant="heading5">
                      Product Image
                    </CustomTypography>

                    <Box mt={1.5}>
                      <Box
                        sx={{
                          height: "24rem",
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor:
                            theme.palette.customColors.greyBackground,
                        }}
                      >
                        <CustomTypography variant="heading6">
                          NO IMAGES FOUND
                        </CustomTypography>
                      </Box>
                    </Box>
                  </Box>
                )}

                <ImageGalleryWithDialog
                  images={
                    projectInventoryOpsStore?.currentPoDetails
                      ?.raw_inward_qc_images
                  }
                  onImageClick={() =>
                    setIsPopupGalleryOpenForRawInward(
                      !isPopupGalleryOpenForRawInward,
                    )
                  }
                  title="1st QC Images"
                  imageKey="image_url"
                  idKey="id"
                  initialVisibleCount={3}
                  emptyMessage="QC IMAGES NOT FOUND"
                />
                <PopupGallery
                  key={"rawInwardQc"}
                  open={isPopupGalleryOpenForRawInward}
                  onClose={() => setIsPopupGalleryOpenForRawInward(false)}
                  images={
                    projectInventoryOpsStore?.currentPoDetails?.raw_inward_qc_images?.map(
                      (img) => ({ id: img.id, src: img.image_url }),
                    ) || []
                  }
                  title={"1st QC Images"}
                  handleDeleteImage={
                    isRawInwardQcLocked
                      ? undefined
                      : (id) => {
                          projectInventoryOpsStore.deleteRawInwardQCImg(id);
                        }
                  }
                />
              </Grid2>

              <Grid2
                size={{ xl: 7.7, lg: 7, md: 12, xs: 12 }}
                mt={{ xl: 0.5, lg: 0, md: 2, sm: 2, xs: 2 }}
              >
                <Box>
                  <Box>
                    <Box
                      display={"flex"}
                      justifyContent={"space-between"}
                      alignItems="center"
                    >
                      <CustomTypography
                        variant="heading5"
                        style={{
                          marginBottom: 10,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ marginRight: 1 }}>
                          <img
                            src={RawInwardIcon}
                            alt="Raw Inward Icon"
                            style={{ width: 24, height: 24 }}
                          />
                        </Box>
                        Raw Inward
                        <span
                          style={{
                            color: theme.palette.customColors.greyTextColor,
                            paddingLeft: "10px",
                          }}
                        >
                          {`(${
                            rawInwardSkuRows.length > 0
                              ? projectInventoryOpsStore.currentPoDetails
                                  ?.raw_inward_quantity || 0
                              : productRawInwardNet
                          }/
                       ${
                         projectInventoryOpsStore.currentPoDetails
                           ?.product_po_quantity || 0
                       })`}
                        </span>
                        <SectionTaskStatus
                          completed={poTaskCompleted("raw_inward")}
                        />
                      </CustomTypography>
                      <Box display="flex" gap={1} flexWrap="wrap">
                        {renderReversalButtons("raw-inward", isArchived)}
                        {canCancelInwards &&
                          projectInventoryOpsStore.currentPoDetails
                            ?.raw_inward_id && (
                            <AppButton
                              label="Cancel"
                              onClick={cancelRawInward}
                              variant="cancel"
                              disabled={isRawInwardCancelLocked}
                              fontSize="0.7rem"
                              customStyles={stageActionButtonSx}
                            />
                          )}
                      </Box>
                    </Box>
                    <InlineFormError
                      message={formErrors[FORM_ERRORS.rawInwardCancel]}
                    />
                    {renderReversalSuccess("raw-inward")}
                    <SectionStageTiming
                      firstLabel="First inward"
                      lastLabel="Last inward"
                      firstAt={
                        projectInventoryOpsStore.currentPoDetails
                          ?.raw_inward_first_inward
                      }
                      lastAt={
                        projectInventoryOpsStore.currentPoDetails
                          ?.raw_inward_last_inward
                      }
                    />
                    <CustomTypography
                      variant="heading6"
                      color={theme.palette.customColors.greyTextColor}
                      style={{ marginBottom: 8 }}
                    >
                      Warehouse *
                    </CustomTypography>
                    <Box
                      sx={{
                        position: "relative",
                        width: "100%",
                        marginBottom: 1.25,
                      }}
                    >
                      <AppSearchDropdownMulti
                        isMultiSelect={false}
                        title="Select Warehouse"
                        local
                        list={
                          warehouseStore.warehouses?.map((warehouse) => ({
                            id: String(warehouse.id),
                            value: String(warehouse.identifier || warehouse.id),
                          })) || []
                        }
                        value={
                          selectedWarehouseId
                            ? [
                                {
                                  id: String(selectedWarehouseId),
                                  value: selectedWarehouseLabel,
                                },
                              ]
                            : []
                        }
                        handleSelect={(selectedItem: FilterValue[]) => {
                          if (isWarehouseSelectionDisabled) return;
                          clearFieldError(FORM_ERRORS.rawInwardWarehouse);
                          if (selectedItem?.length > 0) {
                            projectInventoryOpsStore.updateCurrentPoDetails({
                              warehouse_id: selectedItem[0].id,
                              warehouse_identifier: selectedItem[0].value,
                            });
                          } else {
                            projectInventoryOpsStore.updateCurrentPoDetails({
                              warehouse_id: null,
                              warehouse_identifier: null,
                            });
                          }
                        }}
                        fontSize="12px"
                        disabled={isWarehouseSelectionDisabled}
                        borderColor={theme.palette.customColors.greyDarkborder}
                      />
                      {isWarehouseLockedFromPo && !isRawInwardLocked ? (
                        <CustomTypography
                          variant="body3"
                          sx={{
                            display: "block",
                            mt: 0.75,
                            color: theme.palette.text.secondary,
                          }}
                        >
                          Warehouse is set from the selected PO and cannot be
                          changed.
                        </CustomTypography>
                      ) : null}
                    </Box>
                    <InlineFormError
                      message={formErrors[FORM_ERRORS.rawInwardWarehouse]}
                    />
                    <CustomTypography
                      variant="heading6"
                      color={theme.palette.customColors.greyTextColor}
                      style={{ marginBottom: 8 }}
                    >
                      Quantity Received
                    </CustomTypography>
                    <Box
                      sx={{
                        position: "relative",
                        width: "100%",
                        marginBottom: 1.25,
                      }}
                    >
                      {rawInwardSkuRows.length > 0 ? (
                        <SkuVariantQtyList
                          rows={rawInwardSkuRows}
                          values={
                            projectInventoryOpsStore.currentPoDetails
                              ?.temp_raw_inward_sku_variants
                          }
                          onChange={(lines) => {
                            clearFieldError(FORM_ERRORS.rawInwardQty);
                            projectInventoryOpsStore.updateCurrentPoDetails({
                              temp_raw_inward_sku_variants: lines,
                            });
                          }}
                          recordedLabel="Received"
                          disabled={isRawInwardQtyLocked}
                          selectedSkus={skuSelections.rawInward}
                          onSelectionChange={(sku, selected) =>
                            toggleSkuSelection("rawInward", sku, selected)
                          }
                          onBulkSelectionChange={(skus, selected) =>
                            setSkuSelectionBulk("rawInward", skus, selected)
                          }
                          errorMessage={formErrors[FORM_ERRORS.rawInwardQty]}
                        />
                      ) : (
                        <>
                          <CustomTextField
                            allowDecimalValue={false}
                            allowNegativeValue={false}
                            borderColor={`0.1px solid ${
                              formErrors[FORM_ERRORS.rawInwardQty]
                                ? theme.palette.error.main
                                : theme.palette.customColors.greyDarkborder
                            }`}
                            error={Boolean(
                              formErrors[FORM_ERRORS.rawInwardQty],
                            )}
                            value={
                              projectInventoryOpsStore.currentPoDetails
                                ?.temp_raw_inward_quantity || ""
                            }
                            placeholder="00"
                            width="100%"
                            type="number"
                            onChange={(e) => {
                              clearFieldError(FORM_ERRORS.rawInwardQty);
                              const next = Number(e.target.value);
                              projectInventoryOpsStore.updateCurrentPoDetails({
                                temp_raw_inward_quantity: Number.isNaN(next)
                                  ? 0
                                  : Math.min(
                                      Math.max(0, next),
                                      productRawInwardRemaining,
                                    ),
                              });
                            }}
                            disabled={isRawInwardQtyLocked}
                          />
                          <CustomTypography
                            variant="caption"
                            color={theme.palette.customColors.greyTextColor}
                            style={{ marginTop: 6, display: "block" }}
                          >
                            Remaining: {productRawInwardRemaining}
                          </CustomTypography>
                          <InlineFormError
                            message={formErrors[FORM_ERRORS.rawInwardQty]}
                          />
                        </>
                      )}
                    </Box>
                    {isRawInwardCountedAtQc && (
                      <CustomTypography
                        variant="caption"
                        color={theme.palette.customColors.greyTextColor}
                        style={{ marginBottom: 8, display: "block" }}
                      >
                        This inward is counted at QC. Enter quantities as tested
                        in 1st QC.
                      </CustomTypography>
                    )}
                    {canSwitchRawInwardMode && (
                      <Box sx={{ mb: 1.5 }}>
                        {isRawInwardCountedAtQc ? (
                          <AppButton
                            label="Switch to Quantity Entry"
                            onClick={() => markRawInwardReceived(false)}
                            variant="secondary"
                            customStyles={{ width: "100%" }}
                            disabled={isRawInwardLocked}
                          />
                        ) : (
                          <AppButton
                            label="Mark Received (count at QC)"
                            onClick={() => markRawInwardReceived(true)}
                            variant="secondary"
                            customStyles={{ width: "100%" }}
                            disabled={isRawInwardLocked}
                          />
                        )}
                        <CustomTypography
                          variant="caption"
                          color={theme.palette.customColors.greyTextColor}
                          style={{ marginTop: 6, display: "block" }}
                        >
                          {isRawInwardCountedAtQc
                            ? "Nothing counted yet. Switch back if the count is known and should be entered here."
                            : "Use when the count isn't known yet. The stock is counted in 1st QC."}
                        </CustomTypography>
                        <InlineFormError
                          message={formErrors[FORM_ERRORS.rawInwardReceived]}
                        />
                      </Box>
                    )}
                    <Grid2 container columns={12} spacing={2}>
                      <Grid2 size={{ xs: 12, sm: 6 }}>
                        <AppButton
                          label="Save Quantity"
                          onClick={() => saveRawInwardQty()}
                          variant="primary"
                          customStyles={{ width: "100%" }}
                          disabled={isRawInwardQtyLocked}
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12, sm: 6 }}>
                        <AppButton
                          label="Mark All Complete"
                          onClick={() =>
                            saveRawInwardQty({ useRemaining: true })
                          }
                          variant="primary"
                          customStyles={{ width: "100%" }}
                          disabled={isRawInwardQtyLocked}
                        />
                      </Grid2>
                    </Grid2>
                  </Box>
                  <Box>
                    <InlineFormError
                      message={formErrors[FORM_ERRORS.rawInwardQc]}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 2,
                        marginTop: 2.5,
                        marginBottom: 1.5,
                      }}
                    >
                      <Box>
                        <CustomTypography
                          variant="heading5"
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                          }}
                        >
                          <Box sx={{ marginRight: 1 }}>
                            <img
                              src={QCrejectionIcon}
                              alt="Raw Inward Icon"
                              style={{ width: 24, height: 24 }}
                            />
                          </Box>
                          1st QC
                          <SectionTaskStatus
                            completed={poTaskCompleted("raw_inward_qc")}
                          />
                        </CustomTypography>
                      </Box>
                    </Box>
                    <SectionStageTiming
                      firstLabel="QC started"
                      lastLabel="QC ended"
                      firstAt={
                        projectInventoryOpsStore.currentPoDetails
                          ?.raw_inward_qc_start_time
                      }
                      lastAt={
                        projectInventoryOpsStore.currentPoDetails
                          ?.raw_inward_qc_end_time
                      }
                      cumulativeSeconds={
                        projectInventoryOpsStore.currentPoDetails
                          ?.raw_inward_qc_cumulative
                      }
                    />
                    {rawQc.awaitingQty && (
                      <CustomTypography
                        variant="caption"
                        color={theme.palette.customColors.greyTextColor}
                        style={{ marginBottom: 8, display: "block" }}
                      >
                        Record quantity in Raw Inward first, or mark it received
                        (count at QC) to count the stock here.
                      </CustomTypography>
                    )}
                    <QcStatusSummary
                      snapshot={rawQc}
                      onConfirm={() => saveRawInwardQc({ passRemaining: true })}
                      confirmDisabled={
                        isArchived ||
                        !projectInventoryOpsStore.currentPoDetails.raw_inward_id
                      }
                    />

                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <CustomTypography
                        variant="heading6"
                        color={theme.palette.customColors.greyTextColor}
                        style={{ marginBottom: 8 }}
                      >
                        {rawQc.confirmOnly
                          ? "Quantity Rejected"
                          : "Quantity Tested / Rejected"}
                      </CustomTypography>
                    </Box>
                    {rawInwardQcSkuRows.length > 0 ? (
                      <SkuVariantQtyList
                        rows={rawInwardQcSkuRows}
                        values={
                          projectInventoryOpsStore.currentPoDetails
                            ?.temp_raw_inward_qc_sku_variants
                        }
                        onChange={(lines) => {
                          clearFieldErrors(
                            FORM_ERRORS.rawInwardQcQty,
                            FORM_ERRORS.rawInwardQcSave,
                          );
                          projectInventoryOpsStore.updateCurrentPoDetails({
                            temp_raw_inward_qc_sku_variants: lines,
                          });
                        }}
                        recordedLabel="Rejected"
                        qcMode
                        pendingLabel={
                          rawQc.countAtQc ? "To receive" : "Pending"
                        }
                        hideTestedInput={rawQc.confirmOnly}
                        showRemaining={false}
                        disabled={
                          isRawInwardQcLocked ||
                          !projectInventoryOpsStore.currentPoDetails
                            .raw_inward_id
                        }
                        selectedSkus={skuSelections.rawInwardQc}
                        onSelectionChange={(sku, selected) =>
                          toggleSkuSelection("rawInwardQc", sku, selected)
                        }
                        onBulkSelectionChange={(skus, selected) =>
                          setSkuSelectionBulk("rawInwardQc", skus, selected)
                        }
                        errorMessage={formErrors[FORM_ERRORS.rawInwardQcQty]}
                      />
                    ) : (
                      <QcProductQtyInputs
                        tested={
                          projectInventoryOpsStore.currentPoDetails
                            ?.temp_raw_inward_tested_quantity
                        }
                        rejected={
                          projectInventoryOpsStore.currentPoDetails
                            ?.temp_raw_inward_rejection_quantity
                        }
                        checkableQty={rawQcCheckable}
                        checkableLabel={
                          rawQc.countAtQc ? "To receive" : "Unchecked"
                        }
                        hideTested={rawQc.confirmOnly}
                        onChange={(field, value) => {
                          clearFieldErrors(
                            FORM_ERRORS.rawInwardQcQty,
                            FORM_ERRORS.rawInwardQcSave,
                          );
                          projectInventoryOpsStore.updateCurrentPoDetails(
                            field === "tested"
                              ? { temp_raw_inward_tested_quantity: value }
                              : { temp_raw_inward_rejection_quantity: value },
                          );
                        }}
                        disabled={
                          isRawInwardQcLocked ||
                          !projectInventoryOpsStore.currentPoDetails
                            .raw_inward_id
                        }
                        errorMessage={formErrors[FORM_ERRORS.rawInwardQcQty]}
                      />
                    )}
                    <CustomTypography
                      variant="heading6"
                      color={theme.palette.customColors.greyTextColor}
                      style={{ marginBottom: 8, marginTop: 12 }}
                    >
                      Rejection Reason
                    </CustomTypography>
                    <FormTextField
                      borderColor={`0.1px solid ${theme.palette.customColors.greyDarkborder}`}
                      multiline
                      id="temp_raw_inward_rejection_reason"
                      sx={{
                        flexGrow: 1,
                        marginBottom: "0px",
                        "& .MuiInputBase-root": {
                          height: "100%",
                          alignItems: "start",
                          overflow: "auto",
                        },
                        "& .MuiInputBase-input": {
                          minHeight: "110px",
                          overflowY: "auto",
                          display: "block",
                        },
                      }}
                      value={
                        projectInventoryOpsStore.currentPoDetails
                          ?.temp_raw_inward_rejection_reason || ""
                      }
                      placeholder="Write the rejection reason"
                      onChange={(id, value) => {
                        projectInventoryOpsStore.updateCurrentPoDetails({
                          temp_raw_inward_rejection_reason: value,
                        });
                      }}
                      disabled={
                        isRawInwardQcLocked ||
                        !projectInventoryOpsStore.currentPoDetails.raw_inward_id
                      }
                    />

                    <AppButton
                      label={
                        <Box display={"flex"} alignItems="center">
                          {Boolean(
                            projectInventoryOpsStore.currentPoDetails
                              .raw_inward_id,
                          ) && (
                            <img
                              src={UploadIcon}
                              alt="Upload Icon"
                              style={{ marginRight: 8 }}
                            />
                          )}
                          Upload Images
                        </Box>
                      }
                      onClick={() => setOpenQcPopup(true)}
                      variant="primary"
                      customStyles={{ width: "100%", marginTop: 1.5 }}
                      disabled={
                        isRawInwardQcLocked ||
                        !projectInventoryOpsStore.currentPoDetails.raw_inward_id
                      }
                    />
                    <ImageUploadDialog
                      open={openQcPopup}
                      onClose={() => setOpenQcPopup(false)}
                      onUpload={handleUpload1}
                      multiple={true}
                    />
                    <InlineFormError
                      message={formErrors[FORM_ERRORS.rawInwardQcSave]}
                    />
                    {/* Legacy rows already at the printer: only Confirm QC (banner). */}
                    {!rawQc.confirmOnly && (
                      <Grid2
                        container
                        columns={12}
                        spacing={2}
                        sx={{ mt: 1.5 }}
                      >
                        <Grid2 size={{ xs: 12, sm: rawQc.countAtQc ? 12 : 6 }}>
                          <AppButton
                            label="Save QC Details"
                            onClick={() => saveRawInwardQc()}
                            variant="primary"
                            customStyles={{ width: "100%" }}
                            disabled={
                              isRawInwardQcLocked ||
                              !projectInventoryOpsStore.currentPoDetails
                                .raw_inward_id
                            }
                          />
                        </Grid2>
                        {/* Count at QC has nothing received-but-unchecked to pass. */}
                        {!rawQc.countAtQc && (
                          <Grid2 size={{ xs: 12, sm: 6 }}>
                            <AppButton
                              label="Pass Rest & Close QC"
                              onClick={() =>
                                saveRawInwardQc({ passRemaining: true })
                              }
                              variant="primary"
                              customStyles={{ width: "100%" }}
                              disabled={
                                isRawInwardQcLocked ||
                                rawQc.checkable <= 0 ||
                                !projectInventoryOpsStore.currentPoDetails
                                  .raw_inward_id
                              }
                            />
                          </Grid2>
                        )}
                      </Grid2>
                    )}
                  </Box>
                </Box>
              </Grid2>
            </Grid2>

            <Divider sx={{ mt: 2.5, mb: 2.5 }} />
            {projectInventoryOpsStore.currentPoDetails && (
              <>
                <Grid2
                  container
                  spacing={{ lg: 4, xs: 2 }}
                  columns={{ lg: 12, xs: 12 }}
                  sx={{
                    display: { xl: "flex", lg: "flex", md: "block" },
                    justifyContent: {
                      xl: "space-between",
                      lg: "space-between",
                    },
                  }}
                >
                  <Grid2 size={{ xl: 4.3, lg: 5, md: 12, xs: 12 }}>
                    <Box>
                      <CustomTypography variant="heading5">
                        Size Mix
                      </CustomTypography>

                      <Box mt={1.5}>
                        <Box
                          sx={{
                            height: "21.5rem",
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            overflowX: "auto",
                            padding: 4,
                            backgroundColor:
                              theme.palette.customColors.greyBackground,
                          }}
                        >
                          {projectInventoryOpsStore?.poDetailsBody?.size_mixes
                            ?.length > 0 ? (
                            projectInventoryOpsStore.poDetailsBody.size_mixes.map(
                              (item, index) => {
                                const [rawSize, ...colorParts] =
                                  item.sku?.split("-") || [];
                                const color = colorParts.join(" ");
                                const size =
                                  sizeLabelMap[
                                    rawSize?.toLowerCase() as keyof typeof sizeLabelMap
                                  ] || rawSize;

                                return (
                                  <Box
                                    key={index}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-evenly",
                                      paddingBottom: 3,
                                    }}
                                  >
                                    <CustomTypography
                                      variant="heading7"
                                      color={
                                        theme.palette.customColors.greyTextColor
                                      }
                                      style={{ flex: 1 }}
                                    >
                                      • {size} :
                                    </CustomTypography>

                                    <CustomTypography
                                      variant="heading7"
                                      color={
                                        theme.palette.customColors.greyTextColor
                                      }
                                      style={{
                                        flex: 0.9,
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {color}
                                    </CustomTypography>

                                    <CustomTypography
                                      variant="heading7"
                                      style={{ flex: 0.2, fontWeight: 600 }}
                                    >
                                      {String(item.quantity).padStart(2, "0")}
                                    </CustomTypography>
                                  </Box>
                                );
                              },
                            )
                          ) : (
                            <CustomTypography variant="heading7">
                              No Size Mix Data Available
                            </CustomTypography>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Grid2>

                  <Grid2
                    size={{ xl: 7.7, lg: 7, md: 12, xs: 12 }}
                    mt={{ xl: 0.5, lg: 0, md: 2, sm: 2, xs: 2 }}
                  >
                    {isCustomisationRequired ? (
                      <Box>
                        <Box>
                          <Box
                            display={"flex"}
                            justifyContent={"space-between"}
                            alignItems="center"
                          >
                            <CustomTypography
                              variant="heading5"
                              style={{
                                marginBottom: 10,
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Box sx={{ marginRight: 1 }}>
                                <img
                                  src={PrintOutwardicon}
                                  alt="Raw Inward Icon"
                                  style={{ width: 24, height: 24 }}
                                />
                              </Box>
                              Print Outward
                              <span
                                style={{
                                  color:
                                    theme.palette.customColors.greyTextColor,
                                  paddingLeft: "10px",
                                }}
                              >
                                {`(${
                                  projectInventoryOpsStore.currentPoDetails
                                    .print_outward_quantity || 0
                                }/
                        ${
                          projectInventoryOpsStore.currentPoDetails
                            .product_po_quantity || 0
                        })`}
                              </span>
                              <SectionTaskStatus
                                completed={poTaskCompleted("print_outward")}
                              />
                            </CustomTypography>
                            <Box display="flex" gap={1} flexWrap="wrap">
                              {renderReversalButtons(
                                "print-outward",
                                isArchived || !isCustomisationRequired,
                              )}
                              {canCancelInwards &&
                                projectInventoryOpsStore.currentPoDetails
                                  ?.print_outward_id && (
                                  <AppButton
                                    label="Cancel"
                                    onClick={cancelPrintOutward}
                                    variant="cancel"
                                    disabled={isPrintOutCancelLocked}
                                    fontSize="0.7rem"
                                    customStyles={stageActionButtonSx}
                                  />
                                )}
                            </Box>
                          </Box>
                          <InlineFormError
                            message={formErrors[FORM_ERRORS.printOutwardCancel]}
                          />
                          {renderReversalSuccess("print-outward")}
                          <SectionStageTiming
                            firstLabel="First out"
                            lastLabel="Last out"
                            firstAt={
                              projectInventoryOpsStore.currentPoDetails
                                ?.print_outward_first_out
                            }
                            lastAt={
                              projectInventoryOpsStore.currentPoDetails
                                ?.print_outward_last_out
                            }
                          />

                          <Grid2
                            container
                            size={12}
                            spacing={2}
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Grid2 size={{ xs: 12, sm: 6 }}>
                              <Box>
                                <CustomTypography
                                  variant="heading6"
                                  color={
                                    theme.palette.customColors.greyTextColor
                                  }
                                  style={{ marginBottom: 8 }}
                                >
                                  Printer Name
                                </CustomTypography>
                                <AppSearchDropDown2
                                  isMultiSelect={false}
                                  title={"Select Printer"}
                                  local={false}
                                  borderColor={
                                    theme.palette.customColors.greyDarkborder
                                  }
                                  handleSearch={(searchText) => {
                                    shipmentStore.listPrinterVendors(
                                      searchText,
                                    );
                                  }}
                                  list={shipmentStore.deliveryPartners.map(
                                    (item) => {
                                      return {
                                        id: String(item.delivery_partner_id),
                                        value: item.delivery_partner_name!,
                                      };
                                    },
                                  )}
                                  handleSelect={(
                                    selectedVendor: FilterValue[],
                                  ) => {
                                    clearFieldErrors(
                                      FORM_ERRORS.printOutwardPrinter,
                                      FORM_ERRORS.printOutwardSave,
                                    );
                                    if (
                                      selectedVendor.length > 0 &&
                                      selectedVendor[0].id !== undefined
                                    ) {
                                      projectInventoryOpsStore.updateCurrentPoDetails(
                                        {
                                          temp_print_outward_printer_id: Number(
                                            selectedVendor[0].id,
                                          ),
                                        },
                                      );
                                      projectInventoryOpsStore.updateCurrentPoDetails(
                                        {
                                          temp_print_outward_printer_name:
                                            selectedVendor[0].value,
                                        },
                                      );
                                    } else {
                                      projectInventoryOpsStore.updateCurrentPoDetails(
                                        {
                                          temp_print_outward_printer_id: null,
                                        },
                                      );
                                      projectInventoryOpsStore.updateCurrentPoDetails(
                                        {
                                          temp_print_outward_printer_name: null,
                                        },
                                      );
                                    }
                                  }}
                                  value={
                                    projectInventoryOpsStore.currentPoDetails
                                      .temp_print_outward_printer_id
                                      ? [
                                          {
                                            id: String(
                                              projectInventoryOpsStore
                                                .currentPoDetails
                                                .temp_print_outward_printer_id,
                                            ),
                                            value: String(
                                              projectInventoryOpsStore
                                                .currentPoDetails
                                                .temp_print_outward_printer_name,
                                            ),
                                          },
                                        ]
                                      : undefined
                                  }
                                  disabled={
                                    isPrintOutwardLocked ||
                                    !projectInventoryOpsStore?.currentPoDetails
                                      ?.raw_inward_id
                                  }
                                />
                                <InlineFormError
                                  message={
                                    formErrors[FORM_ERRORS.printOutwardPrinter]
                                  }
                                />
                              </Box>
                            </Grid2>
                            <Grid2 size={{ xs: 12, sm: 6 }}>
                              <Box>
                                <CustomTypography
                                  variant="heading6"
                                  color={
                                    theme.palette.customColors.greyTextColor
                                  }
                                  style={{ marginBottom: 8 }}
                                >
                                  Print Due Date
                                </CustomTypography>
                                <DatePicker2
                                  key={`print_due_date_${
                                    projectInventoryOpsStore.currentPoDetails
                                      .temp_print_outward_timeline
                                      ? projectInventoryOpsStore.currentPoDetails.temp_print_outward_timeline.getTime()
                                      : "null"
                                  }`}
                                  borderColor={`0.1px solid ${
                                    formErrors[FORM_ERRORS.printOutwardTimeline]
                                      ? theme.palette.error.main
                                      : theme.palette.customColors
                                          .greyDarkborder
                                  }`}
                                  onChange={(date) => {
                                    clearFieldErrors(
                                      FORM_ERRORS.printOutwardTimeline,
                                      FORM_ERRORS.printOutwardSave,
                                    );
                                    projectInventoryOpsStore.updateCurrentPoDetails(
                                      {
                                        temp_print_outward_timeline:
                                          date?.toDate(),
                                      },
                                    );
                                  }}
                                  label=""
                                  value={
                                    projectInventoryOpsStore?.currentPoDetails
                                      ?.temp_print_outward_timeline
                                      ? dayjs(
                                          projectInventoryOpsStore
                                            .currentPoDetails
                                            .temp_print_outward_timeline,
                                        )
                                      : null
                                  }
                                  require={false}
                                  error={Boolean(
                                    formErrors[
                                      FORM_ERRORS.printOutwardTimeline
                                    ],
                                  )}
                                  disabled={
                                    isPrintOutwardLocked ||
                                    !projectInventoryOpsStore?.currentPoDetails
                                      ?.raw_inward_id
                                  }
                                />
                                <InlineFormError
                                  message={
                                    formErrors[FORM_ERRORS.printOutwardTimeline]
                                  }
                                />
                              </Box>
                            </Grid2>
                          </Grid2>
                          <CustomTypography
                            variant="heading6"
                            color={theme.palette.customColors.greyTextColor}
                            style={{ marginBottom: 8, marginTop: 16 }}
                          >
                            Quantity Sent
                          </CustomTypography>
                          {printOutwardSkuRows.length > 0 ? (
                            <SkuVariantQtyList
                              rows={printOutwardSkuRows}
                              values={
                                projectInventoryOpsStore.currentPoDetails
                                  ?.temp_print_outward_sku_variants
                              }
                              onChange={(lines) => {
                                clearFieldErrors(
                                  FORM_ERRORS.printOutwardQty,
                                  FORM_ERRORS.printOutwardSave,
                                );
                                projectInventoryOpsStore.updateCurrentPoDetails(
                                  {
                                    temp_print_outward_sku_variants: lines,
                                  },
                                );
                              }}
                              recordedLabel="Sent"
                              disabled={
                                isPrintOutwardLocked ||
                                !projectInventoryOpsStore?.currentPoDetails
                                  ?.raw_inward_id
                              }
                              selectedSkus={skuSelections.printOutward}
                              onSelectionChange={(sku, selected) =>
                                toggleSkuSelection(
                                  "printOutward",
                                  sku,
                                  selected,
                                )
                              }
                              onBulkSelectionChange={(skus, selected) =>
                                setSkuSelectionBulk(
                                  "printOutward",
                                  skus,
                                  selected,
                                )
                              }
                              errorMessage={
                                formErrors[FORM_ERRORS.printOutwardQty]
                              }
                            />
                          ) : (
                            <>
                              <CustomTextField
                                allowDecimalValue={false}
                                allowNegativeValue={false}
                                borderColor={`0.1px solid ${
                                  formErrors[FORM_ERRORS.printOutwardQty]
                                    ? theme.palette.error.main
                                    : theme.palette.customColors.greyDarkborder
                                }`}
                                error={Boolean(
                                  formErrors[FORM_ERRORS.printOutwardQty],
                                )}
                                value={
                                  projectInventoryOpsStore.currentPoDetails
                                    .temp_print_outward_quantity || ""
                                }
                                placeholder="00"
                                width="100%"
                                onChange={(e) => {
                                  clearFieldErrors(
                                    FORM_ERRORS.printOutwardQty,
                                    FORM_ERRORS.printOutwardSave,
                                  );
                                  const next = Number(e.target.value);
                                  projectInventoryOpsStore.updateCurrentPoDetails(
                                    {
                                      temp_print_outward_quantity: Number.isNaN(
                                        next,
                                      )
                                        ? 0
                                        : Math.min(
                                            Math.max(0, next),
                                            productPrintOutwardRemaining,
                                          ),
                                    },
                                  );
                                }}
                                disabled={
                                  isPrintOutwardLocked ||
                                  !projectInventoryOpsStore?.currentPoDetails
                                    ?.raw_inward_id
                                }
                              />
                              <CustomTypography
                                variant="caption"
                                color={theme.palette.customColors.greyTextColor}
                                style={{ marginTop: 6, display: "block" }}
                              >
                                Remaining: {productPrintOutwardRemaining}
                              </CustomTypography>
                              <InlineFormError
                                message={
                                  formErrors[FORM_ERRORS.printOutwardQty]
                                }
                              />
                            </>
                          )}
                        </Box>
                        <InlineFormError
                          message={formErrors[FORM_ERRORS.printOutwardSave]}
                        />
                        {isPrintOutwardAwaitingQc && !isPrintOutwardLocked && (
                          <CustomTypography
                            variant="caption"
                            color={theme.palette.customColors.greyTextColor}
                            style={{ marginTop: 6, display: "block" }}
                          >
                            Pass stock in 1st QC before sending it to the
                            printer.
                          </CustomTypography>
                        )}
                        <Grid2
                          container
                          columns={12}
                          spacing={2}
                          sx={{ marginTop: 2 }}
                        >
                          <Grid2 size={{ xs: 12, sm: 6 }}>
                            <AppButton
                              label="Save Details"
                              onClick={() => {
                                savePrintOutward();
                              }}
                              variant="primary"
                              customStyles={{ width: "100%" }}
                              disabled={
                                isPrintOutwardLocked ||
                                isPrintOutwardAwaitingQc ||
                                !projectInventoryOpsStore?.currentPoDetails
                                  ?.raw_inward_id
                              }
                            />
                          </Grid2>
                          <Grid2 size={{ xs: 12, sm: 6 }}>
                            <AppButton
                              label="Mark All Complete"
                              onClick={() => {
                                savePrintOutward({ useRemaining: true });
                              }}
                              variant="primary"
                              customStyles={{ width: "100%" }}
                              disabled={
                                isPrintOutwardLocked ||
                                isPrintOutwardAwaitingQc ||
                                !projectInventoryOpsStore?.currentPoDetails
                                  ?.raw_inward_id
                              }
                            />
                          </Grid2>
                        </Grid2>
                      </Box>
                    ) : (
                      <CustomisationNotRequiredNotice />
                    )}
                  </Grid2>
                </Grid2>

                {isCustomisationRequired && (
                  <>
                    <Divider sx={{ mt: 2.5, mb: 2.5 }} />

                    <Grid2
                      container
                      spacing={{ lg: 4, xs: 2 }}
                      columns={{ lg: 12, xs: 12 }}
                      sx={{
                        display: { xl: "flex", lg: "flex", md: "block" },
                        justifyContent: {
                          xl: "space-between",
                          lg: "space-between",
                        },
                      }}
                    >
                      <Grid2 size={{ xl: 4.3, lg: 5, md: 12, xs: 12 }}>
                        {projectInventoryOpsStore.productDetailsBody?.mockups
                          ?.length > 0 ? (
                          <Box>
                            <CustomTypography variant="heading5">
                              Product Mockup
                            </CustomTypography>

                            <ImageCarousel
                              images={
                                projectInventoryOpsStore.productDetailsBody
                                  .mockups
                              }
                            />
                          </Box>
                        ) : (
                          <Box>
                            <CustomTypography variant="heading5">
                              Product Mockup
                            </CustomTypography>

                            <Box mt={1.5}>
                              <Box
                                sx={{
                                  height: "24rem",
                                  width: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor:
                                    theme.palette.customColors.greyBackground,
                                }}
                              >
                                <CustomTypography variant="heading6">
                                  No image available
                                </CustomTypography>
                              </Box>
                            </Box>
                          </Box>
                        )}

                        <ImageGalleryWithDialog
                          images={
                            projectInventoryOpsStore?.currentPoDetails
                              ?.print_inward_qc_images
                          }
                          onImageClick={() =>
                            setIsPopupGalleryOpen(!isPopupGalleryOpen)
                          }
                          title="2nd QC Images"
                          imageKey="image_url"
                          idKey="id"
                          initialVisibleCount={3}
                          emptyMessage="QC IMAGES NOT FOUND"
                        />

                        <PopupGallery
                          key={"printInwardQc"}
                          open={isPopupGalleryOpen}
                          onClose={() => setIsPopupGalleryOpen(false)}
                          images={
                            projectInventoryOpsStore?.currentPoDetails?.print_inward_qc_images?.map(
                              (img) => ({ id: img.id, src: img.image_url }),
                            ) || []
                          }
                          title={"2nd QC Images"}
                          handleDeleteImage={
                            isPrintInwardQcLocked
                              ? undefined
                              : (id) => {
                                  projectInventoryOpsStore.deletePrintInwardQCImg(
                                    id,
                                  );
                                }
                          }
                        />
                      </Grid2>

                      <Grid2
                        size={{ xl: 7.7, lg: 7, md: 12, xs: 12 }}
                        mt={{ xl: 0.5, lg: 0, md: 2, sm: 2, xs: 2 }}
                      >
                        <Box sx={{ marginBottom: 2 }}>
                          <Box>
                            <Box
                              display={"flex"}
                              justifyContent={"space-between"}
                              alignItems="center"
                            >
                              <CustomTypography
                                variant="heading5"
                                style={{
                                  marginBottom: 10,
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Box sx={{ marginRight: 1 }}>
                                  <img
                                    src={PrintInwardicon}
                                    alt="Raw Inward Icon"
                                    style={{ width: 24, height: 24 }}
                                  />
                                </Box>
                                Print Inward
                                <span
                                  style={{
                                    color:
                                      theme.palette.customColors.greyTextColor,
                                    paddingLeft: "10px",
                                  }}
                                >
                                  {`(${
                                    printInwardSkuRows.length > 0
                                      ? projectInventoryOpsStore
                                          .currentPoDetails
                                          .print_inward_quantity || 0
                                      : productPrintInwardNet
                                  }/
                        ${
                          printInwardSkuRows.length > 0
                            ? projectInventoryOpsStore.currentPoDetails
                                .product_po_quantity || 0
                            : projectInventoryOpsStore.currentPoDetails
                                .print_outward_quantity || 0
                        })`}
                                </span>
                                <SectionTaskStatus
                                  completed={poTaskCompleted("print_inward")}
                                />
                              </CustomTypography>
                              <Box display="flex" gap={1} flexWrap="wrap">
                                {renderReversalButtons(
                                  "print-inward",
                                  isPrintInwardCancelLocked,
                                )}
                                {canCancelInwards &&
                                  projectInventoryOpsStore.currentPoDetails
                                    ?.print_inward_id && (
                                    <AppButton
                                      label="Cancel"
                                      onClick={cancelPrintInward}
                                      variant="cancel"
                                      disabled={isPrintInwardCancelLocked}
                                      fontSize="0.7rem"
                                      customStyles={stageActionButtonSx}
                                    />
                                  )}
                              </Box>
                            </Box>
                            <InlineFormError
                              message={
                                formErrors[FORM_ERRORS.printInwardCancel]
                              }
                            />
                            {renderReversalSuccess("print-inward")}
                            <SectionStageTiming
                              firstLabel="First inward"
                              lastLabel="Last inward"
                              firstAt={
                                projectInventoryOpsStore.currentPoDetails
                                  ?.print_inward_first_inward
                              }
                              lastAt={
                                projectInventoryOpsStore.currentPoDetails
                                  ?.print_inward_last_inward
                              }
                            />
                            <CustomTypography
                              variant="heading6"
                              color={theme.palette.customColors.greyTextColor}
                              style={{ marginBottom: 8 }}
                            >
                              Quantity Received
                            </CustomTypography>

                            <Box
                              sx={{
                                position: "relative",
                                width: "100%",
                                marginBottom: 1.25,
                              }}
                            >
                              {printInwardSkuRows.length > 0 ? (
                                <SkuVariantQtyList
                                  rows={printInwardSkuRows}
                                  values={
                                    projectInventoryOpsStore.currentPoDetails
                                      ?.temp_print_inward_sku_variants
                                  }
                                  onChange={(lines) => {
                                    clearFieldError(FORM_ERRORS.printInwardQty);
                                    projectInventoryOpsStore.updateCurrentPoDetails(
                                      {
                                        temp_print_inward_sku_variants: lines,
                                      },
                                    );
                                  }}
                                  recordedLabel="Received"
                                  disabled={
                                    isPrintInwardQtyLocked ||
                                    !projectInventoryOpsStore?.currentPoDetails
                                      ?.print_outward_id
                                  }
                                  selectedSkus={skuSelections.printInward}
                                  onSelectionChange={(sku, selected) =>
                                    toggleSkuSelection(
                                      "printInward",
                                      sku,
                                      selected,
                                    )
                                  }
                                  onBulkSelectionChange={(skus, selected) =>
                                    setSkuSelectionBulk(
                                      "printInward",
                                      skus,
                                      selected,
                                    )
                                  }
                                  errorMessage={
                                    formErrors[FORM_ERRORS.printInwardQty]
                                  }
                                />
                              ) : (
                                <>
                                  <CustomTextField
                                    allowDecimalValue={false}
                                    allowNegativeValue={false}
                                    borderColor={`0.1px solid ${
                                      formErrors[FORM_ERRORS.printInwardQty]
                                        ? theme.palette.error.main
                                        : theme.palette.customColors
                                            .greyDarkborder
                                    }`}
                                    error={Boolean(
                                      formErrors[FORM_ERRORS.printInwardQty],
                                    )}
                                    value={
                                      projectInventoryOpsStore.currentPoDetails
                                        .temp_print_inward_quantity || ""
                                    }
                                    placeholder="00"
                                    width="100%"
                                    type="number"
                                    onChange={(e) => {
                                      clearFieldError(
                                        FORM_ERRORS.printInwardQty,
                                      );
                                      const next = Number(e.target.value);
                                      projectInventoryOpsStore.updateCurrentPoDetails(
                                        {
                                          temp_print_inward_quantity:
                                            Number.isNaN(next)
                                              ? 0
                                              : Math.min(
                                                  Math.max(0, next),
                                                  productPrintInwardRemaining,
                                                ),
                                        },
                                      );
                                    }}
                                    disabled={
                                      isPrintInwardQtyLocked ||
                                      !projectInventoryOpsStore
                                        ?.currentPoDetails?.print_outward_id
                                    }
                                  />
                                  <CustomTypography
                                    variant="caption"
                                    color={
                                      theme.palette.customColors.greyTextColor
                                    }
                                    style={{ marginTop: 6, display: "block" }}
                                  >
                                    Remaining: {productPrintInwardRemaining}
                                  </CustomTypography>
                                  <InlineFormError
                                    message={
                                      formErrors[FORM_ERRORS.printInwardQty]
                                    }
                                  />
                                </>
                              )}
                            </Box>
                            {isPrintInwardCountedAtQc && (
                              <CustomTypography
                                variant="caption"
                                color={theme.palette.customColors.greyTextColor}
                                style={{ marginBottom: 8, display: "block" }}
                              >
                                This inward is counted at QC. Enter quantities
                                as tested in 2nd QC.
                              </CustomTypography>
                            )}
                            {canSwitchPrintInwardMode && (
                              <Box sx={{ mb: 1.5 }}>
                                <AppButton
                                  label={
                                    isPrintInwardCountedAtQc
                                      ? "Switch to Quantity Entry"
                                      : "Mark Received (count at QC)"
                                  }
                                  onClick={() =>
                                    markPrintInwardReceived(
                                      !isPrintInwardCountedAtQc,
                                    )
                                  }
                                  variant="secondary"
                                  customStyles={{ width: "100%" }}
                                  disabled={isPrintInwardLocked}
                                />
                                <CustomTypography
                                  variant="caption"
                                  color={
                                    theme.palette.customColors.greyTextColor
                                  }
                                  style={{ marginTop: 6, display: "block" }}
                                >
                                  {isPrintInwardCountedAtQc
                                    ? "Nothing counted yet. Switch back if the count is known and should be entered here."
                                    : "Use when the count isn't known yet. The printed stock is counted in 2nd QC."}
                                </CustomTypography>
                                <InlineFormError
                                  message={
                                    formErrors[FORM_ERRORS.printInwardReceived]
                                  }
                                />
                              </Box>
                            )}
                            <Grid2 container columns={12} spacing={2}>
                              <Grid2 size={{ xs: 12, sm: 6 }}>
                                <AppButton
                                  label="Save Quantity"
                                  onClick={() => savePrintInwardQty()}
                                  variant="primary"
                                  customStyles={{ width: "100%" }}
                                  disabled={
                                    isPrintInwardQtyLocked ||
                                    !projectInventoryOpsStore?.currentPoDetails
                                      ?.print_outward_id
                                  }
                                />
                              </Grid2>
                              <Grid2 size={{ xs: 12, sm: 6 }}>
                                <AppButton
                                  label="Mark All Complete"
                                  onClick={() =>
                                    savePrintInwardQty({ useRemaining: true })
                                  }
                                  variant="primary"
                                  customStyles={{ width: "100%" }}
                                  disabled={
                                    isPrintInwardQtyLocked ||
                                    !projectInventoryOpsStore?.currentPoDetails
                                      ?.print_outward_id
                                  }
                                />
                              </Grid2>
                            </Grid2>
                          </Box>
                          <Box>
                            <InlineFormError
                              message={formErrors[FORM_ERRORS.printInwardQc]}
                            />
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: 2,
                                marginTop: 2.5,
                                marginBottom: 1.5,
                              }}
                            >
                              <Box>
                                <CustomTypography
                                  variant="heading5"
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <Box sx={{ marginRight: 1 }}>
                                    <img
                                      src={QCrejectionIcon2}
                                      alt="Raw Inward Icon"
                                      style={{ width: 24, height: 24 }}
                                    />
                                  </Box>
                                  2nd QC
                                  <SectionTaskStatus
                                    completed={poTaskCompleted(
                                      "print_inward_qc",
                                    )}
                                  />
                                </CustomTypography>
                              </Box>
                            </Box>
                            <SectionStageTiming
                              firstLabel="QC started"
                              lastLabel="QC ended"
                              firstAt={
                                projectInventoryOpsStore.currentPoDetails
                                  ?.print_inward_qc_start_time
                              }
                              lastAt={
                                projectInventoryOpsStore.currentPoDetails
                                  ?.print_inward_qc_end_time
                              }
                              cumulativeSeconds={
                                projectInventoryOpsStore.currentPoDetails
                                  ?.print_inward_qc_cumulative
                              }
                            />
                            {printQc.awaitingQty && (
                              <CustomTypography
                                variant="caption"
                                color={theme.palette.customColors.greyTextColor}
                                style={{ marginBottom: 8, display: "block" }}
                              >
                                Record quantity in Print Inward first, or mark
                                it received (count at QC) to count the stock
                                here.
                              </CustomTypography>
                            )}
                            <QcStatusSummary
                              snapshot={printQc}
                              onConfirm={() =>
                                savePrintInwardQc({ passRemaining: true })
                              }
                              confirmDisabled={
                                isArchived ||
                                !projectInventoryOpsStore.currentPoDetails
                                  .print_inward_id
                              }
                            />

                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <CustomTypography
                                variant="heading6"
                                color={theme.palette.customColors.greyTextColor}
                                style={{ marginBottom: 8 }}
                              >
                                Quantity Tested / Rejected
                              </CustomTypography>
                            </Box>
                            {printInwardQcSkuRows.length > 0 ? (
                              <SkuVariantQtyList
                                rows={printInwardQcSkuRows}
                                values={
                                  projectInventoryOpsStore.currentPoDetails
                                    ?.temp_print_inward_qc_sku_variants
                                }
                                onChange={(lines) => {
                                  clearFieldErrors(
                                    FORM_ERRORS.printInwardQcQty,
                                    FORM_ERRORS.printInwardQcSave,
                                  );
                                  projectInventoryOpsStore.updateCurrentPoDetails(
                                    {
                                      temp_print_inward_qc_sku_variants: lines,
                                    },
                                  );
                                }}
                                recordedLabel="Rejected"
                                qcMode
                                pendingLabel={
                                  printQc.countAtQc ? "To receive" : "Pending"
                                }
                                showRemaining={false}
                                disabled={
                                  isPrintInwardQcLocked ||
                                  !projectInventoryOpsStore.currentPoDetails
                                    .print_inward_id
                                }
                                selectedSkus={skuSelections.printInwardQc}
                                onSelectionChange={(sku, selected) =>
                                  toggleSkuSelection(
                                    "printInwardQc",
                                    sku,
                                    selected,
                                  )
                                }
                                onBulkSelectionChange={(skus, selected) =>
                                  setSkuSelectionBulk(
                                    "printInwardQc",
                                    skus,
                                    selected,
                                  )
                                }
                                errorMessage={
                                  formErrors[FORM_ERRORS.printInwardQcQty]
                                }
                              />
                            ) : (
                              <QcProductQtyInputs
                                tested={
                                  projectInventoryOpsStore.currentPoDetails
                                    .temp_print_inward_tested_quantity
                                }
                                rejected={
                                  projectInventoryOpsStore.currentPoDetails
                                    .temp_print_inward_rejection_quantity
                                }
                                checkableQty={printQcCheckable}
                                checkableLabel={
                                  printQc.countAtQc ? "To receive" : "Unchecked"
                                }
                                onChange={(field, value) => {
                                  clearFieldErrors(
                                    FORM_ERRORS.printInwardQcQty,
                                    FORM_ERRORS.printInwardQcSave,
                                  );
                                  projectInventoryOpsStore.updateCurrentPoDetails(
                                    field === "tested"
                                      ? {
                                          temp_print_inward_tested_quantity:
                                            value,
                                        }
                                      : {
                                          temp_print_inward_rejection_quantity:
                                            value,
                                        },
                                  );
                                }}
                                disabled={
                                  isPrintInwardQcLocked ||
                                  !projectInventoryOpsStore.currentPoDetails
                                    .print_inward_id
                                }
                                errorMessage={
                                  formErrors[FORM_ERRORS.printInwardQcQty]
                                }
                              />
                            )}
                            <CustomTypography
                              variant="heading6"
                              color={theme.palette.customColors.greyTextColor}
                              style={{ marginBottom: 8, marginTop: 12 }}
                            >
                              Rejection Reason
                            </CustomTypography>
                            <FormTextField
                              borderColor={`0.1px solid ${theme.palette.customColors.greyDarkborder}`}
                              multiline
                              id="temp_print_inward_rejection_reason"
                              value={
                                projectInventoryOpsStore.currentPoDetails
                                  .temp_print_inward_rejection_reason || ""
                              }
                              sx={{
                                flexGrow: 1,
                                marginBottom: "0px",
                                "& .MuiInputBase-root": {
                                  height: "100%",
                                  alignItems: "start",
                                  overflow: "auto",
                                },
                                "& .MuiInputBase-input": {
                                  minHeight: "110px",
                                  overflowY: "auto",
                                  display: "block",
                                },
                              }}
                              placeholder="Add additional information"
                              onChange={(id, event) => {
                                projectInventoryOpsStore.updateCurrentPoDetails(
                                  {
                                    temp_print_inward_rejection_reason: event,
                                  },
                                );
                              }}
                              disabled={
                                isPrintInwardQcLocked ||
                                !projectInventoryOpsStore.currentPoDetails
                                  .print_inward_id
                              }
                            />

                            <AppButton
                              label={
                                <Box display={"flex"} alignItems="center">
                                  <img
                                    src={UploadIcon}
                                    alt="Upload Icon"
                                    style={{
                                      marginRight: 8,
                                      display:
                                        isPrintInwardQcLocked ||
                                        !projectInventoryOpsStore
                                          .currentPoDetails.print_inward_id
                                          ? "none"
                                          : "",
                                    }}
                                  />
                                  Upload Images
                                </Box>
                              }
                              onClick={() => setOpenPrintQcPopup(true)}
                              variant="primary"
                              customStyles={{ width: "100%", marginTop: 1.5 }}
                              disabled={
                                isPrintInwardQcLocked ||
                                !projectInventoryOpsStore.currentPoDetails
                                  .print_inward_id
                              }
                            />
                            <ImageUploadDialog
                              open={openPrintQcPopup}
                              onClose={() => setOpenPrintQcPopup(false)}
                              onUpload={handleUpload2}
                              multiple={true}
                            />

                            <InlineFormError
                              message={
                                formErrors[FORM_ERRORS.printInwardQcSave]
                              }
                            />
                            <Grid2
                              container
                              columns={12}
                              spacing={2}
                              sx={{ mt: 1.5 }}
                            >
                              <Grid2
                                size={{
                                  xs: 12,
                                  sm: printQc.countAtQc ? 12 : 6,
                                }}
                              >
                                <AppButton
                                  label="Save QC Details"
                                  onClick={() => {
                                    savePrintInwardQc();
                                  }}
                                  variant="primary"
                                  customStyles={{ width: "100%" }}
                                  disabled={
                                    isPrintInwardQcLocked ||
                                    !projectInventoryOpsStore.currentPoDetails
                                      .print_inward_id
                                  }
                                />
                              </Grid2>
                              {/* Count at QC has nothing received-but-unchecked to pass. */}
                              {!printQc.countAtQc && (
                                <Grid2 size={{ xs: 12, sm: 6 }}>
                                  <AppButton
                                    label="Pass Rest & Close QC"
                                    onClick={() =>
                                      savePrintInwardQc({ passRemaining: true })
                                    }
                                    variant="primary"
                                    customStyles={{ width: "100%" }}
                                    disabled={
                                      isPrintInwardQcLocked ||
                                      printQc.checkable <= 0 ||
                                      !projectInventoryOpsStore.currentPoDetails
                                        .print_inward_id
                                    }
                                  />
                                </Grid2>
                              )}
                            </Grid2>
                          </Box>
                        </Box>
                      </Grid2>
                    </Grid2>
                  </>
                )}
              </>
            )}
          </>
        </Box>
      </Grid2>

      {/* Invoice Information Popup */}
      {selectedInwardId && selectedInvoiceType && (
        <InvoiceInformationPopup
          inwardId={selectedInwardId}
          type={selectedInvoiceType}
          open={isInvoicePopupOpen}
          onClose={handleCloseInvoicePopup}
          onSaveInvoiceDetails={handleSaveInvoiceDetails}
        />
      )}
    </>
  );
};

export default observer(InventoryOpsDetails);
